function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient",
  x1: 336.78,
  y1: 445.94,
  x2: 100.82,
  y2: 445.94,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-2",
  x1: 201.42,
  y1: 294.67,
  x2: 284.75,
  y2: 423.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-3",
  x1: 1157.51,
  y1: -146.47,
  x2: 1370.3,
  y2: -146.47,
  gradientTransform: "translate(-1008.16 556.98)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-4",
  x1: -460.36,
  y1: 396.54,
  x2: -499.13,
  y2: 465.34,
  gradientTransform: "matrix(-1 0 0 1 -306.21 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-5",
  x1: -512.59,
  y1: 409.91,
  x2: -388.8,
  y2: 519.16,
  gradientTransform: "matrix(-.86 -.51 -.51 .86 -15.19 -175.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#edf1f8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#e0e5f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-6",
  x1: -488.56,
  y1: 447.18,
  x2: -467.78,
  y2: 447.18,
  gradientTransform: "matrix(-1 0 0 1 -306.21 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#fff",
  stopOpacity: 0.86
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#fff",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#fff",
  stopOpacity: 0.89
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#fff",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#fff",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#fff",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-7",
  x1: 336.78,
  y1: 350.94,
  x2: 100.82,
  y2: 350.94,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-8",
  x1: 201.42,
  y1: 199.67,
  x2: 284.75,
  y2: 328.61,
  xlinkHref: "#hero_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-9",
  x1: 1157.52,
  y1: -241.47,
  x2: 1370.3,
  y2: -241.47,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-10",
  x1: -430.71,
  y1: 332.54,
  x2: -403.46,
  y2: 332.54,
  gradientTransform: "matrix(-1 0 0 1 -232.87 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#181c45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#353978"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-11",
  x1: -462.86,
  y1: 391.16,
  x2: -419.36,
  y2: 357.14,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-12",
  x1: -423.63,
  y1: 402.14,
  x2: -404.12,
  y2: 351.83,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-13",
  x1: -434.74,
  y1: 397.85,
  x2: -415.21,
  y2: 347.49,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-14",
  x1: 219.34,
  y1: 368.16,
  x2: 202.09,
  y2: 336.94,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-15",
  x1: -444.45,
  y1: 319.77,
  x2: -427.51,
  y2: 319.77,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-16",
  x1: -416.37,
  y1: 348.44,
  x2: -436.73,
  y2: 297.45,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-17",
  x1: -406.75,
  y1: 329.14,
  x2: -379.63,
  y2: 329.14,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-18",
  x1: 596.32,
  y1: -587.43,
  x2: 128.91,
  y2: -68.5,
  gradientTransform: "translate(0 557)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#d8def0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#ebeff7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#f0f3f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#e9edf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#dee3f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-19",
  x1: 270.69,
  y1: -459.7,
  x2: 1235.92,
  y2: 664.3,
  gradientTransform: "translate(0 557)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-20",
  x1: 236.76,
  y1: -287.3,
  x2: 598.27,
  y2: -287.3,
  gradientTransform: "translate(0 557)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-21",
  x1: -1466.33,
  y1: -110.83,
  x2: -1258.47,
  y2: 298.26,
  gradientTransform: "matrix(-1 0 0 1 -818.8 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f0f3f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c8cee5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-22",
  x1: 242.02,
  y1: 498.5,
  x2: 413.14,
  y2: 205.62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4d5690"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#6a72ad"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7981bc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-23",
  x1: 425.59,
  y1: 672.01,
  x2: 314.69,
  y2: 274.25,
  xlinkHref: "#hero_svg__linear-gradient-22"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-24",
  x1: 550.36,
  y1: -1470.41,
  x2: 624.41,
  y2: -1512.38,
  gradientTransform: "matrix(1.01 -.02 -.01 .99 -13.1 1605.19)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#d9dbe9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a3add3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-25",
  x1: 341.25,
  y1: -1372.1,
  x2: 667.89,
  y2: -1557.21,
  xlinkHref: "#hero_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-26",
  x1: 481.5,
  y1: -1123.63,
  x2: 389.66,
  y2: -1390.79,
  gradientTransform: "matrix(1.01 -.02 -.01 .99 -13.1 1605.19)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303573"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303573"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-27",
  x1: 341.25,
  y1: -1372.1,
  x2: 667.89,
  y2: -1557.21,
  xlinkHref: "#hero_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-28",
  x1: 360.12,
  y1: -1309.05,
  x2: 414.09,
  y2: -1487.12,
  gradientTransform: "matrix(1.01 -.02 -.01 .99 -13.1 1605.19)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#171844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#202253"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7a8bc5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-29",
  x1: 562.94,
  y1: -1725.52,
  x2: 592.78,
  y2: -1725.52,
  gradientTransform: "matrix(1.01 -1.18 -.01 .99 -17.7 2512.43)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#64c19a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#36b988"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#21b580"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-30",
  x1: 597.37,
  y1: 98.66,
  x2: 611.25,
  y2: 98.66,
  xlinkHref: "#hero_svg__linear-gradient-29"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-31",
  x1: 402.83,
  y1: -1349.23,
  x2: 685.44,
  y2: -1349.23,
  gradientTransform: "matrix(1.01 -.03 -.01 .99 -12.96 1577.66)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b0bfe2",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b0bfe2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-32",
  x1: 402.79,
  y1: -1229.83,
  x2: 685.4,
  y2: -1229.83,
  xlinkHref: "#hero_svg__linear-gradient-31"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-33",
  x1: 500.33,
  y1: -1807.39,
  x2: 161.37,
  y2: -1266.57,
  gradientTransform: "matrix(1.01 -1.18 -.01 .99 -17.7 2512.43)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7981bc",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#7981bc",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#7981bc",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7981bc",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-34",
  x1: 402.8,
  y1: -1647.06,
  x2: 440.98,
  y2: -1647.06,
  xlinkHref: "#hero_svg__linear-gradient-29"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-35",
  x1: 553.87,
  y1: -1773.84,
  x2: 214.91,
  y2: -1233.02,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-36",
  x1: 558.43,
  y1: -1770.98,
  x2: 219.46,
  y2: -1230.16,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-37",
  x1: 551.98,
  y1: -1775.03,
  x2: 213.01,
  y2: -1234.2,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-38",
  x1: 575.58,
  y1: -1760.23,
  x2: 236.61,
  y2: -1219.41,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-39",
  x1: 569.13,
  y1: -1764.28,
  x2: 230.16,
  y2: -1223.46,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-40",
  x1: 611.87,
  y1: -1737.49,
  x2: 272.9,
  y2: -1196.67,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-41",
  x1: 517.86,
  y1: -1796.41,
  x2: 178.9,
  y2: -1255.59,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-42",
  x1: 646.44,
  y1: -1715.82,
  x2: 307.47,
  y2: -1175,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-43",
  x1: 646.44,
  y1: -1715.82,
  x2: 307.47,
  y2: -1175,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-44",
  x1: 664.19,
  y1: -1704.7,
  x2: 325.22,
  y2: -1163.88,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-46",
  x1: 657.06,
  y1: -1709.16,
  x2: 318.1,
  y2: -1168.34,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-47",
  x1: 673.8,
  y1: -1698.67,
  x2: 334.83,
  y2: -1157.85,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-48",
  x1: 619.79,
  y1: -1732.52,
  x2: 280.83,
  y2: -1191.7,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-49",
  x1: 603.06,
  y1: -1743.01,
  x2: 264.09,
  y2: -1202.19,
  gradientTransform: "matrix(1.49 .44 -.91 .4 -1782.1 639.9)",
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-50",
  x1: 637.55,
  y1: -1721.39,
  x2: 298.58,
  y2: -1180.57,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-51",
  x1: 620.81,
  y1: -1731.88,
  x2: 281.85,
  y2: -1191.06,
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-52",
  x1: 389.7,
  y1: -1860.87,
  x2: 143.66,
  y2: -1860.87,
  gradientTransform: "matrix(1.01 -1.18 -.01 .99 -17.7 2512.43)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303872",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303872"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-53",
  x1: 389.7,
  y1: -1809.9,
  x2: 143.66,
  y2: -1809.9,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-54",
  x1: 389.7,
  y1: -1786.1,
  x2: 143.66,
  y2: -1786.1,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-55",
  x1: 389.7,
  y1: -1762.31,
  x2: 143.66,
  y2: -1762.31,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-56",
  x1: 389.7,
  y1: -1738.52,
  x2: 143.66,
  y2: -1738.52,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-57",
  x1: 408.45,
  y1: -1839.59,
  x2: -62.76,
  y2: -1839.59,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-58",
  x1: 386.78,
  y1: -1432.39,
  x2: 627.94,
  y2: -1432.39,
  gradientTransform: "matrix(1.01 -.02 -.01 .99 -13.16 1616.84)",
  xlinkHref: "#hero_svg__linear-gradient-31"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-59",
  x1: 431.43,
  y1: 416.65,
  x2: 214.03,
  y2: 563.3,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-60",
  x1: 432.63,
  y1: 418.43,
  x2: 215.23,
  y2: 565.08,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-61",
  x1: 432.92,
  y1: 418.86,
  x2: 215.52,
  y2: 565.51,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-62",
  x1: 433.3,
  y1: 419.42,
  x2: 215.9,
  y2: 566.07,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-63",
  x1: 432.63,
  y1: 418.43,
  x2: 215.23,
  y2: 565.07,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-64",
  x1: 433.71,
  y1: 420.03,
  x2: 216.31,
  y2: 566.68,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-65",
  x1: 430.35,
  y1: 415.05,
  x2: 212.95,
  y2: 561.7,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-66",
  x1: 433.92,
  y1: 420.33,
  x2: 216.52,
  y2: 566.98,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-67",
  x1: 325.74,
  y1: 187.82,
  x2: 376.74,
  y2: 187.82,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-68",
  x1: 358.63,
  y1: 177.47,
  x2: 393.72,
  y2: 177.47,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-69",
  x1: 316.72,
  y1: 198.1,
  x2: 356.93,
  y2: 198.1,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-70",
  x1: 311.15,
  y1: 169.29,
  x2: 391.69,
  y2: 169.29,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-71",
  x1: -739.42,
  y1: -294.18,
  x2: -704.35,
  y2: -294.18,
  gradientTransform: "rotate(22.85 -1356.826 2612.633)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-72",
  x1: 626.14,
  y1: 271.67,
  x2: 645.52,
  y2: 271.67,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-73",
  x1: 624.22,
  y1: 303.76,
  x2: 644.61,
  y2: 303.76,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-74",
  x1: 607.81,
  y1: 278.07,
  x2: 648.62,
  y2: 278.07,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-75",
  x1: 603.84,
  y1: 240.22,
  x2: 675.35,
  y2: 240.22,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-76",
  x1: -3266.15,
  y1: -87.8,
  x2: -3233.47,
  y2: -87.8,
  gradientTransform: "rotate(47.61 -1696.697 4483.875)",
  xlinkHref: "#hero_svg__linear-gradient-71"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-77",
  x1: -2413.56,
  y1: -229.2,
  x2: -2082.66,
  y2: -229.2,
  gradientTransform: "matrix(-1 0 0 1 -1605.95 644.77)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#454fa1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#4b58a6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#586ab0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#586caf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2d327e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-78",
  x1: -2285.6,
  y1: -237.88,
  x2: -2149.29,
  y2: -237.88,
  gradientTransform: "matrix(-1 0 0 1 -1605.95 644.77)",
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-79",
  x1: -2057.23,
  y1: -263.43,
  x2: -2337.74,
  y2: -263.43,
  xlinkHref: "#hero_svg__linear-gradient-77"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-80",
  x1: -2390.61,
  y1: -268.75,
  x2: -2098.62,
  y2: -268.75,
  xlinkHref: "#hero_svg__linear-gradient-77"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-81",
  x1: -2277.78,
  y1: -289.01,
  x2: -2157.3,
  y2: -289.01,
  gradientTransform: "matrix(-1 0 0 1 -1605.95 644.77)",
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-82",
  x1: -2082.82,
  y1: -311.58,
  x2: -2318.78,
  y2: -311.58,
  xlinkHref: "#hero_svg__linear-gradient-77"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-83",
  x1: -2178.21,
  y1: -394.42,
  x2: -2178.21,
  y2: -313.66,
  gradientTransform: "matrix(-1 0 0 1 -1605.95 644.77)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3eb883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#3ab180"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#2f9c77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#1c7b6a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#034c56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#014955"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-84",
  x1: -2178.17,
  y1: -394.42,
  x2: -2178.17,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-85",
  x1: -2207.5,
  y1: -382.27,
  x2: -2153.26,
  y2: -382.27,
  gradientTransform: "matrix(-1 0 0 1 -1605.95 644.77)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#014955"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3eb883"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-86",
  x1: -2177.63,
  y1: -394.42,
  x2: -2177.63,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-87",
  x1: -2207.5,
  y1: -358.36,
  x2: -2153.26,
  y2: -358.36,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-88",
  x1: -2205.41,
  y1: -385.45,
  x2: -2187.6,
  y2: -302.98,
  gradientTransform: "matrix(-1 0 0 1 -1605.95 644.77)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3eb883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#014955"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-89",
  x1: -2210.87,
  y1: -384.27,
  x2: -2193.07,
  y2: -301.8,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-90",
  x1: -2225.86,
  y1: -381.04,
  x2: -2208.05,
  y2: -298.56,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-91",
  x1: -2219.4,
  y1: -394.42,
  x2: -2219.4,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-92",
  x1: -2229.7,
  y1: -380.21,
  x2: -2211.89,
  y2: -297.73,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-93",
  x1: -2207.97,
  y1: -394.42,
  x2: -2207.97,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-94",
  x1: -2216.72,
  y1: -383.01,
  x2: -2198.92,
  y2: -300.54,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-95",
  x1: -2204.01,
  y1: -394.42,
  x2: -2204.01,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-96",
  x1: -2207.5,
  y1: -323.38,
  x2: -2153.26,
  y2: -323.38,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-97",
  x1: -2216.85,
  y1: -382.98,
  x2: -2199.04,
  y2: -300.51,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-98",
  x1: -2220.07,
  y1: -395.62,
  x2: -2184.07,
  y2: -395.62,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-99",
  x1: -2205.72,
  y1: -385.38,
  x2: -2187.92,
  y2: -302.91,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-100",
  x1: -2220.07,
  y1: -366.13,
  x2: -2184.07,
  y2: -366.13,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-101",
  x1: -2217.93,
  y1: -394.42,
  x2: -2217.93,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-102",
  x1: -2228.49,
  y1: -380.47,
  x2: -2210.68,
  y2: -298,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-103",
  x1: -2220.07,
  y1: -331.05,
  x2: -2184.07,
  y2: -331.05,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-104",
  x1: -2235.5,
  y1: -401.02,
  x2: -2269.59,
  y2: -305.85,
  gradientTransform: "matrix(-1 0 0 1 -1605.95 644.77)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3eb883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#38ae7f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#299273"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#106561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#014955"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-105",
  x1: -2243.45,
  y1: -403.87,
  x2: -2277.54,
  y2: -308.7,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-106",
  x1: -2186.6,
  y1: -383.51,
  x2: -2220.69,
  y2: -288.34,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-107",
  x1: -2240.14,
  y1: -377.95,
  x2: -2222.33,
  y2: -295.48,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-108",
  x1: -2196.07,
  y1: -386.9,
  x2: -2230.16,
  y2: -291.73,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-109",
  x1: -2231.77,
  y1: -379.76,
  x2: -2213.97,
  y2: -297.29,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-110",
  x1: -2183.77,
  y1: -382.49,
  x2: -2217.86,
  y2: -287.33,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-111",
  x1: -2214.23,
  y1: -394.42,
  x2: -2214.23,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-112",
  x1: -2230.99,
  y1: -379.93,
  x2: -2213.18,
  y2: -297.46,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-113",
  x1: -2188.13,
  y1: -384.05,
  x2: -2222.22,
  y2: -288.89,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-114",
  x1: -2222.47,
  y1: -394.42,
  x2: -2222.47,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-115",
  x1: -2236.29,
  y1: -378.79,
  x2: -2218.48,
  y2: -296.31,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-116",
  x1: -2195.25,
  y1: -386.6,
  x2: -2229.34,
  y2: -291.44,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-117",
  x1: -2220.07,
  y1: -285.61,
  x2: -2184.07,
  y2: -285.61,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-118",
  x1: -2183.09,
  y1: -382.25,
  x2: -2217.18,
  y2: -287.08,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-119",
  x1: -2236.77,
  y1: -378.68,
  x2: -2218.96,
  y2: -296.21,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-120",
  x1: -2220.07,
  y1: -295.16,
  x2: -2184.07,
  y2: -295.16,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-121",
  x1: -2187.02,
  y1: -383.66,
  x2: -2221.11,
  y2: -288.49,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-122",
  x1: -2219.44,
  y1: -394.42,
  x2: -2219.44,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-123",
  x1: -2233.59,
  y1: -379.37,
  x2: -2215.78,
  y2: -296.89,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-124",
  x1: -2220.07,
  y1: -313.87,
  x2: -2184.07,
  y2: -313.87,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-125",
  x1: -2193.48,
  y1: -385.97,
  x2: -2227.57,
  y2: -290.8,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-126",
  x1: -2229.3,
  y1: -398.8,
  x2: -2263.39,
  y2: -303.63,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-127",
  x1: -2286.07,
  y1: -345.62,
  x2: -2213.63,
  y2: -310.11,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-128",
  x1: -2248.74,
  y1: -376.1,
  x2: -2230.93,
  y2: -293.62,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-129",
  x1: -2201.17,
  y1: -388.72,
  x2: -2235.26,
  y2: -293.56,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-130",
  x1: -2292.9,
  y1: -331.69,
  x2: -2220.46,
  y2: -296.18,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-131",
  x1: -2150.21,
  y1: -353.55,
  x2: -2153.23,
  y2: -275,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-132",
  x1: -2142.13,
  y1: -353.24,
  x2: -2145.15,
  y2: -274.69,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-133",
  x1: -2167.35,
  y1: -354.21,
  x2: -2170.37,
  y2: -275.66,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-134",
  x1: -2141.48,
  y1: -353.22,
  x2: -2144.51,
  y2: -274.66,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-135",
  x1: -2147.13,
  y1: -353.43,
  x2: -2150.15,
  y2: -274.88,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-136",
  x1: -2168.49,
  y1: -354.26,
  x2: -2171.51,
  y2: -275.7,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-137",
  x1: -2146.38,
  y1: -353.41,
  x2: -2149.4,
  y2: -274.85,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-138",
  x1: -2168.35,
  y1: -354.25,
  x2: -2171.37,
  y2: -275.7,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-139",
  x1: -2168.17,
  y1: -354.24,
  x2: -2171.19,
  y2: -275.69,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-140",
  x1: -2147.92,
  y1: -353.47,
  x2: -2150.94,
  y2: -274.91,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-141",
  x1: -2167.66,
  y1: -354.22,
  x2: -2170.68,
  y2: -275.67,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-142",
  x1: -2145.64,
  y1: -353.38,
  x2: -2148.66,
  y2: -274.82,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-143",
  x1: -2143.46,
  y1: -353.29,
  x2: -2146.48,
  y2: -274.74,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-144",
  x1: -2142.81,
  y1: -353.27,
  x2: -2145.83,
  y2: -274.72,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-145",
  x1: -2144.19,
  y1: -353.32,
  x2: -2147.21,
  y2: -274.77,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-146",
  x1: -2148.66,
  y1: -353.49,
  x2: -2151.68,
  y2: -274.94,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-147",
  x1: -2144.89,
  y1: -353.35,
  x2: -2147.91,
  y2: -274.8,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-148",
  x1: -2164.24,
  y1: -354.09,
  x2: -2167.26,
  y2: -275.54,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-149",
  x1: -2164.82,
  y1: -354.12,
  x2: -2167.84,
  y2: -275.56,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-150",
  x1: -2167.92,
  y1: -354.23,
  x2: -2170.94,
  y2: -275.68,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-151",
  x1: -2159.22,
  y1: -353.9,
  x2: -2162.24,
  y2: -275.35,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-152",
  x1: -2159.92,
  y1: -353.93,
  x2: -2162.94,
  y2: -275.37,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-153",
  x1: -2165.33,
  y1: -354.13,
  x2: -2168.35,
  y2: -275.58,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-154",
  x1: -2151,
  y1: -353.58,
  x2: -2154.02,
  y2: -275.03,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-155",
  x1: -2160.56,
  y1: -353.95,
  x2: -2163.59,
  y2: -275.4,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-156",
  x1: -2163.72,
  y1: -354.07,
  x2: -2166.74,
  y2: -275.52,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-157",
  x1: -2161.9,
  y1: -354,
  x2: -2164.92,
  y2: -275.45,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-158",
  x1: -2161.23,
  y1: -353.98,
  x2: -2164.26,
  y2: -275.42,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-159",
  x1: -2163.11,
  y1: -354.05,
  x2: -2166.13,
  y2: -275.5,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-160",
  x1: -2165.79,
  y1: -354.15,
  x2: -2168.82,
  y2: -275.6,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-161",
  x1: -2166.66,
  y1: -354.19,
  x2: -2169.68,
  y2: -275.63,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-162",
  x1: -2151.76,
  y1: -353.61,
  x2: -2154.78,
  y2: -275.06,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-163",
  x1: -2166.25,
  y1: -354.17,
  x2: -2169.27,
  y2: -275.62,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-164",
  x1: -2167.02,
  y1: -354.2,
  x2: -2170.04,
  y2: -275.65,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-165",
  x1: -2158.52,
  y1: -353.87,
  x2: -2161.54,
  y2: -275.32,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-166",
  x1: -2169.25,
  y1: -354.29,
  x2: -2172.27,
  y2: -275.73,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-167",
  x1: -2188.01,
  y1: -394.42,
  x2: -2188.01,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-168",
  x1: -2187.05,
  y1: -354.97,
  x2: -2190.07,
  y2: -276.42,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-169",
  x1: -2221.47,
  y1: -381.98,
  x2: -2203.67,
  y2: -299.51,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-170",
  x1: -2199.82,
  y1: -355.46,
  x2: -2202.84,
  y2: -276.91,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-171",
  x1: -2203.13,
  y1: -394.42,
  x2: -2203.13,
  y2: -313.66,
  xlinkHref: "#hero_svg__linear-gradient-83"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-172",
  x1: -2220.3,
  y1: -382.24,
  x2: -2202.5,
  y2: -299.76,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-173",
  x1: -2200.95,
  y1: -355.5,
  x2: -2203.97,
  y2: -276.95,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-174",
  x1: -2173.2,
  y1: -378.71,
  x2: -2207.29,
  y2: -283.54,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-175",
  x1: -2204.54,
  y1: -355.64,
  x2: -2207.56,
  y2: -277.09,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-176",
  x1: -2228.16,
  y1: -380.54,
  x2: -2210.35,
  y2: -298.07,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-177",
  x1: -2175.18,
  y1: -379.42,
  x2: -2209.27,
  y2: -284.25,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-178",
  x1: -2205.12,
  y1: -355.67,
  x2: -2208.15,
  y2: -277.11,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-179",
  x1: -2127.97,
  y1: -366.77,
  x2: -2198.5,
  y2: -348.9,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-180",
  x1: -2117.53,
  y1: -325.55,
  x2: -2188.06,
  y2: -307.68,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-181",
  x1: -2122.53,
  y1: -345.31,
  x2: -2193.06,
  y2: -327.44,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-182",
  x1: -2123.89,
  y1: -350.65,
  x2: -2194.42,
  y2: -332.79,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-183",
  x1: -2117.98,
  y1: -327.33,
  x2: -2188.51,
  y2: -309.47,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-184",
  x1: -2127.54,
  y1: -365.09,
  x2: -2198.07,
  y2: -347.23,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-185",
  x1: -2125.2,
  y1: -355.85,
  x2: -2195.73,
  y2: -337.99,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-186",
  x1: -2117.07,
  y1: -323.72,
  x2: -2187.6,
  y2: -305.86,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-187",
  x1: -2127.42,
  y1: -364.61,
  x2: -2197.95,
  y2: -346.75,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-188",
  x1: -2120.84,
  y1: -338.63,
  x2: -2191.37,
  y2: -320.76,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-189",
  x1: -2119.69,
  y1: -334.08,
  x2: -2190.22,
  y2: -316.21,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-190",
  x1: -2120.07,
  y1: -335.6,
  x2: -2190.6,
  y2: -317.73,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-191",
  x1: -2118.42,
  y1: -329.08,
  x2: -2188.96,
  y2: -311.22,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-192",
  x1: -2120.46,
  y1: -337.14,
  x2: -2191,
  y2: -319.28,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-193",
  x1: -2121.55,
  y1: -341.43,
  x2: -2192.08,
  y2: -323.57,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-194",
  x1: -2121.21,
  y1: -340.07,
  x2: -2191.74,
  y2: -322.21,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-195",
  x1: -2118.85,
  y1: -330.78,
  x2: -2189.39,
  y2: -312.92,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-196",
  x1: -2122.22,
  y1: -344.09,
  x2: -2192.76,
  y2: -326.22,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-197",
  x1: -2121.89,
  y1: -342.76,
  x2: -2192.42,
  y2: -324.9,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-198",
  x1: -2119.27,
  y1: -332.43,
  x2: -2189.8,
  y2: -314.56,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-199",
  x1: -2127.17,
  y1: -363.61,
  x2: -2197.7,
  y2: -345.75,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-200",
  x1: -2115.6,
  y1: -317.92,
  x2: -2186.13,
  y2: -300.06,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-201",
  x1: -2126.89,
  y1: -362.51,
  x2: -2197.42,
  y2: -344.64,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-202",
  x1: -2126.57,
  y1: -361.25,
  x2: -2197.1,
  y2: -343.39,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-203",
  x1: -2125.84,
  y1: -358.36,
  x2: -2196.37,
  y2: -340.5,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-204",
  x1: -2127.03,
  y1: -363.05,
  x2: -2197.56,
  y2: -345.19,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-205",
  x1: -2116.09,
  y1: -319.89,
  x2: -2186.63,
  y2: -302.02,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-206",
  x1: -2114.01,
  y1: -311.65,
  x2: -2184.54,
  y2: -293.79,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-207",
  x1: -2126.03,
  y1: -359.11,
  x2: -2196.56,
  y2: -341.25,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-208",
  x1: -2115.08,
  y1: -315.88,
  x2: -2185.61,
  y2: -298.01,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-209",
  x1: -2126.22,
  y1: -359.87,
  x2: -2196.75,
  y2: -342,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-210",
  x1: -2114.55,
  y1: -313.8,
  x2: -2185.08,
  y2: -295.93,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-211",
  x1: -2126.4,
  y1: -360.56,
  x2: -2196.93,
  y2: -342.7,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-212",
  x1: -2126.73,
  y1: -361.87,
  x2: -2197.26,
  y2: -344,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-213",
  x1: -2125.63,
  y1: -357.53,
  x2: -2196.16,
  y2: -339.66,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-214",
  x1: -2125.41,
  y1: -356.68,
  x2: -2195.95,
  y2: -338.82,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-215",
  x1: -2116.58,
  y1: -321.81,
  x2: -2187.11,
  y2: -303.95,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-216",
  x1: -2127.31,
  y1: -364.18,
  x2: -2197.84,
  y2: -346.31,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-217",
  x1: -2157.73,
  y1: -353.84,
  x2: -2160.75,
  y2: -275.29,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-218",
  x1: -2120.44,
  y1: -337.04,
  x2: -2190.97,
  y2: -319.17,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-219",
  x1: -2283.16,
  y1: -365.38,
  x2: -2308.73,
  y2: -310.2,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-220",
  x1: -2257.07,
  y1: -353.29,
  x2: -2282.64,
  y2: -298.1,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-221",
  x1: -2216.46,
  y1: -394.2,
  x2: -2250.55,
  y2: -299.04,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-222",
  x1: -2230.97,
  y1: -341.19,
  x2: -2256.54,
  y2: -286.01,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-223",
  x1: -2211.85,
  y1: -392.55,
  x2: -2245.94,
  y2: -297.38,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-224",
  x1: -2297.83,
  y1: -321.63,
  x2: -2225.39,
  y2: -286.12,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-225",
  x1: -2226.54,
  y1: -339.14,
  x2: -2252.12,
  y2: -283.96,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-226",
  x1: -2299.12,
  y1: -347.63,
  x2: -2254.92,
  y2: -287.07,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-227",
  x1: -2261.25,
  y1: -355.23,
  x2: -2286.82,
  y2: -300.04,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-228",
  x1: -2297.21,
  y1: -349.03,
  x2: -2253.01,
  y2: -288.46,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-229",
  x1: -2301.16,
  y1: -346.98,
  x2: -2257.01,
  y2: -346.98,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-230",
  x1: -2261.43,
  y1: -355.31,
  x2: -2287,
  y2: -300.13,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-231",
  x1: -2301.16,
  y1: -318.66,
  x2: -2257.01,
  y2: -318.66,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-232",
  x1: -2288.19,
  y1: -367.71,
  x2: -2313.77,
  y2: -312.53,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-233",
  x1: -2301.16,
  y1: -346.49,
  x2: -2257.01,
  y2: -346.49,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-234",
  x1: -2299.15,
  y1: -347.61,
  x2: -2254.96,
  y2: -287.04,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-235",
  x1: -2301.16,
  y1: -346.82,
  x2: -2257.01,
  y2: -346.82,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-236",
  x1: -2261.71,
  y1: -355.44,
  x2: -2287.28,
  y2: -300.26,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-237",
  x1: -2295.93,
  y1: -349.96,
  x2: -2251.74,
  y2: -289.39,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-238",
  x1: -2301.16,
  y1: -318.81,
  x2: -2257.01,
  y2: -318.81,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-239",
  x1: -2282.37,
  y1: -383.23,
  x2: -2227.81,
  y2: -383.23,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-240",
  x1: -2235.96,
  y1: -401.19,
  x2: -2270.05,
  y2: -306.02,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-241",
  x1: -2282.37,
  y1: -346.02,
  x2: -2227.81,
  y2: -346.02,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-242",
  x1: -2194.2,
  y1: -386.23,
  x2: -2228.28,
  y2: -291.06,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-243",
  x1: -2282.37,
  y1: -287.91,
  x2: -2227.81,
  y2: -287.91,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-244",
  x1: -2267.34,
  y1: -412.43,
  x2: -2301.43,
  y2: -317.26,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-245",
  x1: -2282.37,
  y1: -382.2,
  x2: -2227.81,
  y2: -382.2,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-246",
  x1: -2247.8,
  y1: -376.3,
  x2: -2230,
  y2: -293.83,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-247",
  x1: -2200.8,
  y1: -388.59,
  x2: -2234.89,
  y2: -293.43,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-248",
  x1: -2282.37,
  y1: -302.3,
  x2: -2227.81,
  y2: -302.3,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-249",
  x1: -2270,
  y1: -378.39,
  x2: -2197.56,
  y2: -342.88,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-250",
  x1: -2282.37,
  y1: -382.47,
  x2: -2227.81,
  y2: -382.47,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-251",
  x1: -2236.1,
  y1: -401.24,
  x2: -2270.19,
  y2: -306.07,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-252",
  x1: -2280.28,
  y1: -357.43,
  x2: -2207.84,
  y2: -321.92,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-253",
  x1: -2282.37,
  y1: -345.46,
  x2: -2227.81,
  y2: -345.46,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-254",
  x1: -2194.68,
  y1: -386.4,
  x2: -2228.77,
  y2: -291.23,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-255",
  x1: -2297.86,
  y1: -321.56,
  x2: -2225.42,
  y2: -286.05,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-256",
  x1: -2282.37,
  y1: -288.27,
  x2: -2227.81,
  y2: -288.27,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-257",
  x1: -2248.07,
  y1: -376.24,
  x2: -2230.26,
  y2: -293.77,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-258",
  x1: -2200.95,
  y1: -388.65,
  x2: -2235.04,
  y2: -293.48,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-259",
  x1: -2292.75,
  y1: -331.99,
  x2: -2220.31,
  y2: -296.48,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-260",
  x1: -2282.37,
  y1: -302.17,
  x2: -2227.81,
  y2: -302.17,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-261",
  x1: -2183.14,
  y1: -367.32,
  x2: -2133.11,
  y2: -367.32,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-262",
  x1: -2157.18,
  y1: -353.82,
  x2: -2160.21,
  y2: -275.27,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-263",
  x1: -2183.14,
  y1: -327.87,
  x2: -2133.11,
  y2: -327.87,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-264",
  x1: -2128.44,
  y1: -368.65,
  x2: -2198.98,
  y2: -350.79,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-265",
  x1: -2183.14,
  y1: -367.05,
  x2: -2133.11,
  y2: -367.05,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-266",
  x1: -2157.06,
  y1: -353.82,
  x2: -2160.09,
  y2: -275.26,
  xlinkHref: "#hero_svg__linear-gradient-88"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-267",
  x1: -2120.53,
  y1: -337.4,
  x2: -2191.06,
  y2: -319.54,
  xlinkHref: "#hero_svg__linear-gradient-104"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-268",
  x1: -2183.14,
  y1: -327.9,
  x2: -2133.11,
  y2: -327.9,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "hero_svg__radial-gradient",
  cx: -2218.4,
  cy: -2217.81,
  r: 99.82,
  gradientTransform: "matrix(-1 0 0 .55 -1605.95 1612.26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#454fa1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#5560ab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#6a77b8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#7a88c3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#8694ca"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#8c9bce"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "hero_svg__radial-gradient-2",
  cx: -2218.37,
  cy: -2225.54,
  r: 88.09,
  gradientTransform: "matrix(-1 0 0 .55 -1605.95 1568.26)",
  xlinkHref: "#hero_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "hero_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-1",
  d: "M197.42 313.91c-6.91-4.76-23.39-2.81-31 12.25-2.44 4.88 7.08 1.56 3.39 12-5.38 15.26 29.25 18.31 36.87 14.27 1.77-.94 6.82-16.28 3-20.2 1.37-3.59.82-6-.28-7.9-1.35-2.51-8.97-8.33-11.98-10.42z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "hero_svg__clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-1",
  d: "M273.06 240.72v265.63a10.67 10.67 0 005.45 9.31l11.59 6.51a10.67 10.67 0 0010.56-.07l319.75-184.6a10.68 10.68 0 005.33-9.25V60.17a10.67 10.67 0 00-5.45-9.31l-11.55-6.48a10.68 10.68 0 00-10.62.09l-319.78 187a10.67 10.67 0 00-5.28 9.25z"
})), /*#__PURE__*/React.createElement("style", null, ".hero_svg__cls-1{fill:none}.hero_svg__cls-3{fill:#fff}.hero_svg__cls-47,.hero_svg__cls-7{fill:#a3add3}.hero_svg__cls-7{opacity:.5}.hero_svg__cls-23{fill:#878ec2}.hero_svg__cls-24{fill:#3eb883}.hero_svg__cls-25{fill:#7dc9a9}.hero_svg__cls-29{fill:#2d327e}.hero_svg__cls-43{fill:#565e97}.hero_svg__cls-45{fill:#555d97}.hero_svg__cls-58{fill:url(#hero_svg__linear-gradient-44)}.hero_svg__cls-83{fill:#221f34}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  id: "hero_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-1",
  d: "M158.5 253.68h39v39h-39zm0 81h39v39h-39zm0-41h39v40h-39zm0-120h39v39h-39zm0 40h39v39h-39zm0-81h39v40h-39zm-40 0h39v40h-39zm0 41h39v39h-39zm0-81h39v39h-39zm0-40h39v39h-39zm80 80h39v40h-39zm0 41h39v39h-39zm-80 40h39v39h-39zm80 0h39v39h-39zm0-121h39v39h-39zm0 201h39v40h-39zm0 41h39v39h-39zm-40-282h39v39h-39zm0 40h39v39h-39zm40 161h39v39h-39zm-161-80h39v39h-39zm161-121h39v39h-39zm-161 80h39v40h-39zm40 202h40v39h-40zm41-81h39v39h-39zm-81-40h39v39h-39zm0-161h39v39h-39zm0 201h39v39h-39zm0 81h39v39h-39zm0-41h39v40h-39zm0-201h39v39h-39zm40 0h40v39h-40zm0-40h40v39h-40zm41 282h39v39h-39zm0-41h39v40h-39zm-41-80h40v39h-40zm0 80h40v40h-40zm0-40h40v39h-40zm0-121h40v40h-40zm0 41h40v39h-40zm323 80h39v39h-39zm-41 0h40v39h-40zm0-80h40v39h-40zm0 40h40v39h-40zm0-81h40v40h-40zm0-40h40v39h-40zm-40 0h39v39h-39zm40 201h40v40h-40zm0-241h40v39h-40zm-40 0h39v39h-39zm40 282h40v39h-40zm41-282h39v39h-39zm0 40h39v39h-39zm0 242h39v39h-39zm-162 0h40v39h-40zm81-202h39v40h-39zm81 161h39v40h-39zm0-161h39v40h-39zm0 81h39v39h-39zm0-40h39v39h-39zm-121 120h39v40h-39zm-41-120h40v39h-40zm0-41h40v40h-40zm0-40h40v39h-40zm0-40h40v39h-40zm41 282h39v39h-39zm0-81h39v39h-39zm-41 40h40v40h-40zm81-120h39v39h-39zm-81 40h40v39h-40zm0 40h40v39h-40zm81 0h39v39h-39zm-40-201h39v39h-39zm40 241h39v40h-39zm0 41h39v39h-39zm0-121h39v39h-39zm-40-121h39v39h-39zm0 121h39v39h-39zm0-40h39v39h-39zm0-41h39v40h-39z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M474 52.68v-1h-33.5v-37h-1v37h-39v-37h-1v37h-40v-37h-1v37h-39v-37h-1v37h-39v-37h-1v37h-40v-37h-1v37h-39v-37h-1v37h-39v-37h-1v37h-39v-37h-1v37h-40v-37h-1v37h-39v-37h-1v37H0v1h36.5v39H0v1h36.5v39H0v1h36.5v40H0v1h36.5v39H0v1h36.5v39H0v1h36.5v39H0v1h36.5v40H0v1h36.5v39H0v1h36.5v37h1v-37h39v37h1v-37h40v37h1v-37h39v37h1v-37h39v37h1v-37h39v37h1v-37h40v37h1v-37h39v37h1v-37h39v37h1v-37h40v37h1v-37h39v37h1v-37H474v-1h-33.5v-39H474v-1h-33.5v-40H474v-1h-33.5v-39H474v-1h-33.5v-39H474v-1h-33.5v-39H474v-1h-33.5v-40H474v-1h-33.5v-39H474v-1h-33.5v-39zm-397.5 321h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm41 282h-40v-39h40zm0-40h-40v-40h40zm0-41h-40v-39h40zm0-40h-40v-39h40zm0-40h-40v-39h40zm0-40h-40v-40h40zm0-41h-40v-39h40zm0-40h-40v-39h40zm40 282h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm40 282h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm40 282h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm41 282h-40v-39h40zm0-40h-40v-40h40zm0-41h-40v-39h40zm0-40h-40v-39h40zm0-40h-40v-39h40zm0-40h-40v-40h40zm0-41h-40v-39h40zm0-40h-40v-39h40zm40 282h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm40 282h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm41 282h-40v-39h40zm0-40h-40v-40h40zm0-41h-40v-39h40zm0-40h-40v-39h40zm0-40h-40v-39h40zm0-40h-40v-40h40zm0-41h-40v-39h40zm0-40h-40v-39h40zm40 282h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-39h39zm0-40h-39v-40h39zm0-41h-39v-39h39zm0-40h-39v-39h39z"
})), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M246.79 437.16l-98.53-58.65v71.81a6.15 6.15 0 003.12 5.38l95.41 55.15a18.67 18.67 0 0018.71 0L360.15 456a6.21 6.21 0 003.12-5.38v-72.06l-97.72 58.69a19 19 0 01-18.76-.09z",
  fill: "url(#hero_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.79 437.16l-97-56a3.11 3.11 0 010-5.39L246 320.3a18.64 18.64 0 0118.72 0l97 55.95a3.1 3.1 0 010 5.38l-96.22 55.53a18.67 18.67 0 01-18.71 0z",
  fill: "url(#hero_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.14 440.61a19.18 19.18 0 01-9.83-2.65l-97-55.95.94-1.65 97 55.95a17.84 17.84 0 0017.77 0l96.16-55.53.94 1.66L266 438a19.15 19.15 0 01-9.83 2.65z",
  fill: "url(#hero_svg__linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-7",
  d: "M177.54 467c-13-7.52-23.23-25.12-23.23-40.07 0-6 1.62-11.17 4.69-15a17.36 17.36 0 0113.82-6.52 25.22 25.22 0 0112.6 3.71c13 7.52 23.22 25.12 23.22 40.07 0 6-1.62 11.17-4.68 15a17.37 17.37 0 01-13.82 6.52 25.22 25.22 0 01-12.6-3.71zm24.82-4.1c2.76-3.44 4.23-8.18 4.23-13.7 0-14.28-9.75-31.11-22.2-38.29a23.17 23.17 0 00-11.57-3.43 15.35 15.35 0 00-12.22 5.75c-2.77 3.45-4.23 8.19-4.23 13.7 0 14.29 9.75 31.11 22.2 38.29a23.16 23.16 0 0011.57 3.44 15.38 15.38 0 0012.22-5.76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.77 449.2c0-12.21-8.64-27.1-19.29-33.25-5.65-3.26-10.73-3.41-14.26-1l-18.71 10.52 26.93 47.22L195 461.62c3.57-1.96 5.77-6.26 5.77-12.42z",
  fill: "url(#hero_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 162.07,
  cy: 449.02,
  rx: 15.69,
  ry: 27.18,
  transform: "rotate(-30.35 162.03 448.97)",
  fill: "url(#hero_svg__linear-gradient-5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.07 426.91c10.65 6.15 19.29 21 19.29 33.25a18.13 18.13 0 01-1.52 7.73",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  stroke: "url(#hero_svg__linear-gradient-6)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.79 342.16l-98.53-58.65v71.81a6.15 6.15 0 003.12 5.38l95.41 55.15a18.67 18.67 0 0018.71 0L360.15 361a6.21 6.21 0 003.12-5.38v-72.06l-97.72 58.69a19 19 0 01-18.76-.09z",
  fill: "url(#hero_svg__linear-gradient-7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.79 342.16l-97-56a3.11 3.11 0 010-5.39L246 225.3a18.64 18.64 0 0118.72 0l97 55.95a3.1 3.1 0 010 5.38l-96.22 55.53a18.67 18.67 0 01-18.71 0z",
  fill: "url(#hero_svg__linear-gradient-8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.14 345.61a19.18 19.18 0 01-9.83-2.65l-97-55.95.94-1.65 97 55.95a17.84 17.84 0 0017.77 0l96.16-55.53.94 1.66L266 343a19.15 19.15 0 01-9.83 2.65z",
  fill: "url(#hero_svg__linear-gradient-9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184 369.16c-6.91-1.41-5.94-9.26-4.89-14.53 1.53-7.69-2.48-17-4.27-24.61a178.86 178.86 0 01-4.21-25c-.37-4.18 6.87-13.55 10.26-7.17 1.35 2.55-3.09 1.24-3.09 1.24s6.56-5.53 8.5 2.59c-.68 1.28-3-.15-3-.15s6.32-3.4 7.58 3.66c-.3-1.69-4.77 1.34-5.15 2.11-.91 1.92-.54 5.12-.24 7.12a67.09 67.09 0 002 9.18c3 10.24 9.2 20.12 10.3 30.86.8 7.94-5.3 16.44-13.79 14.7z",
  fill: "url(#hero_svg__linear-gradient-10)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.58 371.35l8.66 19 13.24-2.05s.38 15.31 6.33 18.94 9.32.39 14.95 1.22c.48-2.7-4.08-4.79-4.08-4.79a14.23 14.23 0 016.13-.4c.36-3-4-4.6-4-4.6a10.92 10.92 0 014.53-.76c-.1-4.5-9.49-3-9.49-3s7.64-25.61-7.12-29c-12.8-3-29.15 5.44-29.15 5.44z",
  fill: "url(#hero_svg__linear-gradient-11)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.35 388.66c-2.87-12.8-15.18-20.1-15.18-20.1L176 378.67l8.88 13.18s-13.71 7-14.43 13.88 4 9.26 5.39 13.91c3.84-1.23 2-5.58 2-5.58a14.91 14.91 0 014.77 5.33c2.78-1.91 1.29-5.71 1.29-5.71a12.18 12.18 0 015.35 3.65c2.61-4.39-4.12-9.7-4.12-9.7s26.52-4.28 23.22-18.97z",
  fill: "url(#hero_svg__linear-gradient-12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.86 349.08c-5.9-12.91-30.38-8.82-28.79-2.25 3.71 15.38-2.71 19.85-.26 31.22 2.29 10.68 9 13.18 12.28 15.61 7.86 5.86 20.26-6.32 23.79-16.34 3.32-9.38-3.81-21.2-7.02-28.24z",
  fill: "url(#hero_svg__linear-gradient-13)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.85 319.79c-.85-3.7-3.11-4.12-5-3.71a8.12 8.12 0 00-2.14-1.88 4.6 4.6 0 00-3.31.62c-4.63 2.33-5.26 7-5.89 11.59-.68 5-1.61 10-2.65 15-.78 3.74-.26 6.6-4.35 7.54-6 1.36-14.27 0-18.12 5.92a6.88 6.88 0 00-.26 7c2 3.55 6.62 4.59 10.68 4.49 5.32-.12 10.47-1.6 15.52-3.13 3.77-1.14 7.77-2.46 9.71-6.25 1.75-3.42 1.17-8.48 1.39-12.23.24-4.08.52-8.39 1.08-12.31a16.7 16.7 0 011.14-4.59c1.22-2.66 3.76-4.08 6.62-3.15-.35-3.99-2.54-4.89-4.42-4.91z",
  fill: "url(#hero_svg__linear-gradient-14)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196 324.14c-5.35-7.92 7.09-6.16 5.32-18.37a17.85 17.85 0 017.1 10.82c1 5.45 4.08 8.64 2.92 13.27-1.07 4.3-6.11 4.54-8.54 3.14-4.08-2.34-4.74-5.81-6.8-8.86z",
  fill: "url(#hero_svg__linear-gradient-15)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.42 313.91c-6.91-4.76-23.39-2.81-31 12.25-2.44 4.88 7.08 1.56 3.39 12-5.38 15.26 29.25 18.31 36.87 14.27 1-.52 5.34-7.42 3.89-10.9a18.11 18.11 0 00.19-3.11c2.52-1.81-.11-5.21-1.06-6.19 1.37-3.59.82-6-.28-7.9-1.37-2.51-8.99-8.33-12-10.42z",
  fill: "url(#hero_svg__linear-gradient-16)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hero_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M214.09 339c.78-.74 2-2 1.55-3a.09.09 0 00-.11 0 .11.11 0 00-.05 0 4.64 4.64 0 01-2.73 1.94.08.08 0 00-.06.1l1.25 1a.11.11 0 00.12 0zm-1.98 1.54a12.94 12.94 0 001.33-1 .08.08 0 000-.14l-1.34-1.05a.11.11 0 00-.12 0 .05.05 0 000 .05v2c-.08.18.02.21.13.14zm-.92.19l.06-2.14a.23.23 0 00-.26-.2h-.05l-.48.09c-.43.07-.92.16-1.45.21h-.12c-.14 0-.25.13-.24.24a.2.2 0 00.08.13l2.31 1.71a.11.11 0 00.13 0s.02-.02.02-.04zm-4.26 2.15a27.35 27.35 0 003.36-1.34.27.27 0 00.15-.39l-.06-.06-2.73-2a.11.11 0 00-.12 0l-1 3.47c0 .16.07.3.26.32a.41.41 0 00.14 0zm-1.25.12l1.07-3.71c0-.15-.07-.29-.26-.32h-.09l-1.42.11c-.83.07-1.64.13-2.54.23a.24.24 0 00-.25.23.16.16 0 00.05.11l3.28 3.39a.09.09 0 00.12 0 .1.1 0 00.04-.04zm-4.5 1.37c1.18-.24 2.27-.5 3.29-.77a.29.29 0 00.26-.35.24.24 0 00-.06-.09l-2.81-3a.11.11 0 00-.12 0l-.92 3.83c0 .15.08.29.27.31zm-1.32-.09a.1.1 0 00.12 0 .12.12 0 00.05-.05l1.06-4.42c0-.15-.09-.29-.28-.31h-.1l-1.56.25-1.56.3c-.19 0-.32.19-.28.34s0 0 0 .08zm-4.37.9c1-.1 2.16-.23 3.36-.4.19 0 .33-.17.31-.32a.29.29 0 000-.1l-2.19-3.28a.09.09 0 00-.12 0l-1.64 3.74a.25.25 0 00.22.34zm-1.18-.18l1.91-4.3a.19.19 0 00-.16-.26h-.14c-.88.22-1.66.43-2.47.66l-1.48.4c-.14 0-.23.15-.19.26a.08.08 0 000 .05l2.34 3.21a.09.09 0 00.11 0 .1.1 0 00.08-.02zm-5 .21a27.21 27.21 0 003.62.12.36.36 0 00.36-.29.26.26 0 000-.15l-2.2-2.89a.1.1 0 00-.12 0l-1.87 2.83a.24.24 0 00.15.37zm-1.91-2.46l.78 2a.08.08 0 00.11 0 .09.09 0 00.05 0l1.6-2.4a.19.19 0 00-.1-.28.4.4 0 00-.19 0h-.11c-.52.13-1 .22-1.43.29l-.49.08c-.14 0-.25.13-.23.24s0 .06.01.07zm-1.73 1.68a13.66 13.66 0 001.58.45c.14 0 .21 0 .17-.14l-.74-1.89s-.06-.05-.11 0l-.9 1.44v.14zm-1.41-.6c.18.1.38.19.58.28a.09.09 0 00.12 0l.84-1.33a.06.06 0 000-.09 6.37 6.37 0 01-2-.22 3 3 0 01-1.22-.68.13.13 0 00-.12 0 .09.09 0 000 .06.83.83 0 00.05.35 3.57 3.57 0 001.75 1.63z",
  id: "hero_svg__Teeth"
})), /*#__PURE__*/React.createElement("path", {
  d: "M147.06 315.94a1.07 1.07 0 01.68-.35 1.11 1.11 0 01.64.11 33.58 33.58 0 0016.24 3.61 13.46 13.46 0 014.28.41 7.18 7.18 0 012.65 1.7c2.87 3.39 3.86 16-1.64 20.77a12.57 12.57 0 01-6.57.12l.95-3.56-3.51 2.38a13.57 13.57 0 01-4.55-5.35l2.3-2.26-3.3-.06c-.21-.61-.39-1.22-.52-1.74-1.37-5.48-5.18-9.73-6.33-11.85-.27-.48-1.22-2.22-1.45-2.6a1.12 1.12 0 01.13-1.33z",
  fill: "url(#hero_svg__linear-gradient-17)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M169.8 329.65c-.91-1.52-2-3.73-7.28-4.94h-.09a29.77 29.77 0 01-6.34-1.7 32.32 32.32 0 01-9.16-5.71c.23.38 1.18 2.12 1.45 2.6 1.15 2.12 5 6.37 6.33 11.85.13.52.31 1.13.52 1.74l3.3.06-2.3 2.26a13.57 13.57 0 004.55 5.35l3.51-2.38-.95 3.56a11.43 11.43 0 006.58-.13c.05-.43.11-.85.17-1.24.56-3.63 1.35-8.58-.29-11.32zm22.64-14.5c.52-.43 3-.15 3-.15.58.07 1 .54.68.87a3 3 0 01-2.54.61c-1.21-.23-1.64-.91-1.11-1.33zm-.12 2.59c1.38 0 .67 1.61-.15 1.82s-2.1-.24-1.95-.83 1.39-1 2.1-1zM188 315a2.67 2.67 0 012.36 1.53c.13.63-.57.92-2.28 1.24s-3.3-.56-3.32-1.09S187 315.12 188 315z"
}), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow_Eyes",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M195.85 333.08a8 8 0 002.09-.81s-1.47-.34-3.5-.87c-5.56-1.44-9.39-4.15-12.16-3.74-1.68.25-1.88 2.64-1.88 2.64a8.34 8.34 0 012.73-.75 15 15 0 015.78 1.28"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M188.91 330.84a16.09 16.09 0 00-5.16 0 7.33 7.33 0 00.34 2 5.61 5.61 0 006.48 4 6.25 6.25 0 005.28-3.73"
}))), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-2",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-25",
  d: "M190.91 332.29A10.77 10.77 0 00187 332a4.22 4.22 0 00.2 1.16 3.3 3.3 0 003.81 2.33 3.67 3.67 0 003.09-2.19 10.67 10.67 0 00-3.19-1.01z",
  id: "hero_svg__Brow_Eyes-2",
  "data-name": "Brow + Eyes"
})), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-3",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow_Eyes-3",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M206.33 329.61a6.36 6.36 0 012.78-1.7 3.19 3.19 0 011.49.17s-.42-1.73-1.3-1.67c-1.47.06-3.08 2.55-5.71 4.34a23.31 23.31 0 01-2.16 1.29 8.64 8.64 0 001.66.13"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M203.09 332.17a3.19 3.19 0 003.16 2c1.94-.17 2.72-2 2.79-3.75A7.41 7.41 0 00209 329a6 6 0 00-2.62.66"
}))), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-4",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-25",
  d: "M205.54 331.1a4.25 4.25 0 011.84-.69 2.71 2.71 0 01.05.75 1.74 1.74 0 01-3.3 1 5.27 5.27 0 011.41-1.06z",
  id: "hero_svg__Brow_Eyes-4",
  "data-name": "Brow + Eyes"
})), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M192.14 332.62s1.77 0 2 .76-2.66-.29-3.36-.4-.16-.52 1.37-.36zm13.4-1.45s-1.06.36-1.08 1 1.55-.75 1.95-1 0-.45-.87 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588.82.49a3.55 3.55 0 00-3.59 0l-355 204.75a9.11 9.11 0 00-4.54 7.84v312.64a3.55 3.55 0 001.83 3.15l12.75 7.4-2.12-315.94a9.1 9.1 0 014.54-7.84L601.27 7.67z",
  fill: "url(#hero_svg__linear-gradient-18)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.7 212.42L597.54 7.75A3.62 3.62 0 01603 10.9v312.64a9 9 0 01-4.54 7.84L243.65 536a3.62 3.62 0 01-5.42-3.15V220.18a8.9 8.9 0 014.47-7.76z",
  fill: "url(#hero_svg__linear-gradient-19)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.69 532.9h-2.93V220.18a10.45 10.45 0 015.24-9.08L596.8 6.5l1.47 2.57-354.84 204.59a7.58 7.58 0 00-3.81 6.52l.07 312.72z",
  fill: "url(#hero_svg__linear-gradient-20)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-29",
  d: "M259.25 221.57L580.84 36.1a3.86 3.86 0 015.78 3.37V313.8a9.57 9.57 0 01-4.83 8.35L260.2 507.63a3.87 3.87 0 01-5.78-3.37V230a9.85 9.85 0 014.83-8.43z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hero_svg__clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-21)",
  d: "M268.83 232.11v278.01l26.57 15.02 330.34-190.72V53.92L599.17 38.9 268.83 232.11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-22)",
  d: "M268.58 233.29l2.33 279.62 24.59 15.04 87.07-50.27V197.19L356 182.16l-87.42 51.13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f1f4fa",
  d: "M382.32 197.25l.23 277.92 243.19-140.26V54.41L382.32 197.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.4 254.21v270.93l87.15-50.46-.23-277.92L301 244.5a11.26 11.26 0 00-5.6 9.71z",
  fill: "url(#hero_svg__linear-gradient-23)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M590.37 111.24a3.09 3.09 0 01-1.54 2.62l-26.94 15.92a1.06 1.06 0 01-1.61-.9v-7.72a3.08 3.08 0 011.53-2.62l26.95-16.27a1.06 1.06 0 011.61.89zm13.89-3.49c-3.83 2.26-6.91 0-6.89-5s3.16-10.92 7-13.18 6.91 0 6.88 5-3.16 10.92-6.99 13.18z",
  fill: "url(#hero_svg__linear-gradient-24)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-25)",
  d: "M383.07 206.64l.16.07v-.17l-.16.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-26)",
  d: "M383.07 206.64l.16.07v-.17l-.16.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M383.05 206.65l.18.06-.16-.07z",
  fill: "url(#hero_svg__linear-gradient-27)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M383.05 206.65l.18.06-.16-.07z",
  fill: "url(#hero_svg__linear-gradient-28)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588.8 102.27l-26.95 16.27a3.08 3.08 0 00-1.53 2.62v7.72a1.06 1.06 0 001.61.9l26.94-15.92a3.09 3.09 0 001.54-2.62v-8.08a1.06 1.06 0 00-1.61-.89z",
  fill: "url(#hero_svg__linear-gradient-29)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.36 89.56c-3.83 2.26-7 8.16-7 13.18s3.06 7.27 6.89 5 7-8.16 7-13.18-3.06-7.25-6.89-5z",
  fill: "url(#hero_svg__linear-gradient-30)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-1",
  d: "M485 261.69l12.9-7.69a6.26 6.26 0 002.57-4.87c0-1.84-1.13-2.65-2.53-1.81L485.06 255a6.28 6.28 0 00-2.56 4.87c-.01 1.85 1.12 2.67 2.5 1.82zm108-28.76c3.89-2.33 7.07-8.37 7.1-13.46s-3.11-7.34-7-5-7.06 8.37-7.09 13.47 3.13 7.32 6.99 4.99zm-2-10a1.39 1.39 0 01.57-1.08l3-1.79c.32-.18.57 0 .57.41v3.89a1.42 1.42 0 01-.58 1.09l-3 1.78c-.31.19-.56 0-.56-.4zm2.23-29.26c3.89-2.34 7.07-8.38 7.1-13.47s-3.11-7.34-7-5-7.06 8.37-7.09 13.46 3.11 7.34 6.99 5.01zm-2-9.95a1.41 1.41 0 01.57-1.09l3-1.78c.31-.19.56 0 .56.4v3.9a1.42 1.42 0 01-.57 1.08l-3 1.78c-.31.19-.56 0-.56-.4zM484.82 299.64l12.88-7.73a6.28 6.28 0 002.56-4.87c0-1.85-1.12-2.66-2.53-1.82L484.86 293a6.29 6.29 0 00-2.57 4.87c-.01 1.8 1.13 2.61 2.53 1.77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-31)",
  d: "M420.65 266.88v.28l-22.08 13.26-.01 1.79 204.79-122.99.01-2.06-182.71 109.72z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-43",
  d: "M420.65 266.88v-1.2l-22.08 13.26v1.48-.28l22.08-13.26z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-43",
  d: "M420.65 266.88l-22.08 13.26v.28l22.08-13.26v-.28z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-32)",
  d: "M436.43 376.08l-38.5 23.12-.01 1.79L602.71 278l.01-2.07-166.29 99.87v.28z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M436.43 375.8l.01-1.2-38.5 23.12-.01 1.48v-.28l38.5-23.12z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M436.43 375.8l-38.5 23.12v.28l38.5-23.12v-.28z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-45",
  d: "M416.38 285.77c-1.28-2.16-3.68-2.69-6.46-1-4.13 2.48-7.51 8.89-7.54 14.32 0 3.63 1.47 5.89 3.7 6.24a5.58 5.58 0 003.74-.92 13 13 0 003.49-3.23 2.17 2.17 0 01-.48-1.52 5.51 5.51 0 012.26-4.29 1.46 1.46 0 011.38-.19 16.79 16.79 0 00.89-5.09 8.32 8.32 0 00-.98-4.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M416.58 297.4v-.01.01zm-1.51 2.86zm.02-3.93z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-7",
  d: "M416.09 296.24a1 1 0 00-1 .09 3.68 3.68 0 00-1.51 2.86 1.37 1.37 0 00.38 1.08.91.91 0 001.11 0 3.71 3.71 0 001.51-2.86 1.28 1.28 0 00-.49-1.17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.55 294.56c0 .41.25.59.56.4l25.51-15.32a1.39 1.39 0 00.57-1.08v-4.11c0-.41-.25-.59-.56-.4l-25.51 15.31a1.41 1.41 0 00-.57 1.09z",
  fill: "url(#hero_svg__linear-gradient-33)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-47",
  d: "M459.26 260.31l-33.07 19.85a1.41 1.41 0 00-.57 1.09v4.1c0 .41.25.59.56.41l33.07-19.86a1.42 1.42 0 00.57-1.08v-4.11c0-.41-.25-.59-.56-.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-43",
  d: "M399.11 274.13l21.06-12.65a1.26 1.26 0 00.51-1v-5.73c0-.37-.22-.54-.5-.37l-21.06 12.65a1.27 1.27 0 00-.52 1v5.73c0 .37.23.54.51.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.64 392.4l37.15-22.3a1.69 1.69 0 00.68-1.29v-5.31c0-.49-.3-.7-.68-.48l-37.14 22.31a1.66 1.66 0 00-.69 1.29v5.3c.04.49.3.71.68.48z",
  fill: "url(#hero_svg__linear-gradient-34)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-7",
  d: "M446.05 357.77v5.3c0 .49.3.71.67.48l29-17.42a1.63 1.63 0 00.68-1.29v-5.31c0-.49-.29-.7-.67-.48l-29 17.42a1.65 1.65 0 00-.68 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-47",
  d: "M425.4 323.3c0 .41.24.59.56.4L459 303.84a1.37 1.37 0 00.57-1.08v-4.11c0-.41-.25-.59-.56-.4L426 318.11a1.35 1.35 0 00-.57 1.08zm33.22 55.24l-33.06 19.86a1.36 1.36 0 00-.57 1.08v4.11c0 .41.25.59.57.4l33.06-19.85a1.41 1.41 0 00.57-1.09v-4.1c-.01-.41-.26-.59-.57-.41z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.47 413.41L451 398.1a1.36 1.36 0 00.57-1.08v-4.11c0-.41-.24-.59-.56-.4l-25.51 15.31a1.42 1.42 0 00-.57 1.08v4.11c-.02.41.23.59.54.4z",
  fill: "url(#hero_svg__linear-gradient-35)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.41 222c0-.41-.25-.59-.56-.41l-41.28 24.8a1.39 1.39 0 00-.57 1.08v4.11c0 .41.25.59.56.4l41.28-24.79a1.41 1.41 0 00.57-1.09z",
  fill: "url(#hero_svg__linear-gradient-36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485 263.18l12.87-7.73a9.07 9.07 0 003.71-7c0-2.66-1.63-3.83-3.66-2.61l-12.87 7.73a9 9 0 00-3.7 7c0 2.65 1.65 3.83 3.65 2.61zm0-8.17l12.88-7.73c1.4-.84 2.54 0 2.53 1.81a6.26 6.26 0 01-2.51 4.91l-12.9 7.69c-1.41.85-2.54 0-2.53-1.81a6.28 6.28 0 012.59-4.88z",
  fill: "url(#hero_svg__linear-gradient-37)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.65 259.55l-41.28 24.79a1.36 1.36 0 00-.57 1.08v4.11c0 .41.25.59.57.4l41.28-24.79a1.42 1.42 0 00.57-1.08v-4.11c-.01-.41-.22-.59-.57-.4z",
  fill: "url(#hero_svg__linear-gradient-38)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.82 301.12l12.87-7.73a9 9 0 003.7-7c0-2.66-1.62-3.83-3.65-2.61l-12.87 7.73a9 9 0 00-3.71 7c-.01 2.66 1.63 3.83 3.66 2.61zm0-8.17l12.87-7.73c1.41-.84 2.54 0 2.53 1.82a6.28 6.28 0 01-2.56 4.87l-12.88 7.73c-1.4.84-2.54 0-2.53-1.82a6.29 6.29 0 012.61-4.82z",
  fill: "url(#hero_svg__linear-gradient-39)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.21 339.84l-41.28 24.8a1.4 1.4 0 00-.57 1.08v4.11c0 .41.25.59.56.4l41.28-24.8a1.36 1.36 0 00.57-1.08v-4.11c.01-.41-.24-.59-.56-.4z",
  fill: "url(#hero_svg__linear-gradient-40)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.34 333.34c0 .41.25.59.56.4l25.51-15.32a1.39 1.39 0 00.57-1.08v-4.11c0-.41-.25-.59-.56-.4l-25.51 15.32a1.4 1.4 0 00-.57 1.08z",
  fill: "url(#hero_svg__linear-gradient-41)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593.23 195.15c4.5-2.71 8.2-9.72 8.23-15.63s-3.61-8.52-8.12-5.81-8.2 9.72-8.23 15.63 3.61 8.52 8.12 5.81zm-7-6.49c0-5.09 3.21-11.13 7.09-13.46s7-.09 7 5-3.21 11.13-7.1 13.47-7.01.08-6.98-5.01z",
  fill: "url(#hero_svg__linear-gradient-42)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.78 188l3-1.78a1.42 1.42 0 00.57-1.08v-3.9c0-.41-.25-.59-.56-.4l-3 1.78a1.41 1.41 0 00-.57 1.09v3.89c0 .4.25.6.56.4z",
  fill: "url(#hero_svg__linear-gradient-43)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-58",
  d: "M593 234.42c4.5-2.71 8.2-9.72 8.23-15.63s-3.61-8.52-8.12-5.81-8.2 9.72-8.23 15.63 3.63 8.51 8.12 5.81zm.1-20c3.89-2.33 7-.08 7 5s-3.21 11.13-7.1 13.46-7 .09-7-5 3.24-11.09 7.12-13.42z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-58",
  d: "M591.57 227.28l3-1.78a1.42 1.42 0 00.58-1.09v-3.89c0-.41-.25-.59-.57-.41l-3 1.79a1.39 1.39 0 00-.58 1.1v3.9c0 .39.26.57.57.38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M547.83 323.48c-3.15 1.89-5.72 6.77-5.74 10.89s2.51 5.94 5.66 4.05 5.71-6.76 5.73-10.89-2.48-5.94-5.65-4.05z",
  fill: "url(#hero_svg__linear-gradient-46)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.11 313.1c-3.11 1.9-5.71 6.77-5.73 10.9s2.51 5.94 5.65 4.05 5.72-6.77 5.74-10.89-2.51-5.95-5.66-4.06z",
  fill: "url(#hero_svg__linear-gradient-47)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.68 208.55c3.14-1.89 5.71-6.76 5.73-10.89s-2.51-5.94-5.65-4-5.76 6.72-5.76 10.84 2.53 5.94 5.68 4.05z",
  fill: "url(#hero_svg__linear-gradient-48)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 548.43,
  cy: 211.46,
  rx: 8.74,
  ry: 4.85,
  transform: "rotate(-65.76 548.43 211.46)",
  fill: "url(#hero_svg__linear-gradient-49)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.46 247.84c3.15-1.89 5.72-6.77 5.74-10.9s-2.51-5.93-5.66-4-5.71 6.76-5.73 10.89 2.51 5.89 5.65 4.01z",
  fill: "url(#hero_svg__linear-gradient-50)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548.18 258.22c3.14-1.89 5.71-6.77 5.73-10.9s-2.51-5.93-5.65-4-5.72 6.76-5.74 10.89 2.48 5.9 5.66 4.01z",
  fill: "url(#hero_svg__linear-gradient-51)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-45",
  d: "M416.18 325c-1.28-2.15-3.68-2.68-6.45-1-4.14 2.49-7.52 8.9-7.55 14.32 0 3.63 1.47 5.89 3.7 6.25a5.65 5.65 0 003.74-.93 13 13 0 003.49-3.22 2.17 2.17 0 01-.48-1.52 5.56 5.56 0 012.26-4.3 1.52 1.52 0 011.38-.19 16.68 16.68 0 00.89-5.09 8.32 8.32 0 00-.98-4.32z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-7",
  d: "M415.89 335.45a1 1 0 00-1 .08 3.69 3.69 0 00-1.51 2.87 1.43 1.43 0 00.38 1.08.91.91 0 001.11 0 3.67 3.67 0 001.51-2.86 1.25 1.25 0 00-.49-1.17z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-45",
  d: "M416.22 404.41c-1.28-2.15-3.68-2.68-6.45-1-4.14 2.49-7.52 8.9-7.55 14.32 0 3.63 1.48 5.89 3.7 6.25a5.63 5.63 0 003.74-.93 13 13 0 003.49-3.22 2.22 2.22 0 01-.48-1.52 5.54 5.54 0 012.27-4.3 1.52 1.52 0 011.38-.19 16.65 16.65 0 00.88-5.08 8.33 8.33 0 00-.98-4.33z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M415.93 414.89a1 1 0 00-1 .08 3.65 3.65 0 00-1.51 2.86 1.4 1.4 0 00.39 1.08.9.9 0 001.1 0 3.67 3.67 0 001.51-2.86 1.25 1.25 0 00-.49-1.16z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-7",
  d: "M397.72 217.82v8.54a1.16 1.16 0 001.77 1l33-19.47a3.42 3.42 0 001.7-2.91v-8.92a1.16 1.16 0 00-1.78-1l-33 19.87a3.41 3.41 0 00-1.69 2.89z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362.4 236.11l-44.95 26.66a3.76 3.76 0 00-1.86 3.2v9.78a.89.89 0 001.36.75l44.94-26.24a3.77 3.77 0 001.88-3.21v-10.19a.89.89 0 00-1.37-.75z",
  fill: "url(#hero_svg__linear-gradient-52)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.81 293.17l-37.43 22.21a3.13 3.13 0 00-1.55 2.66v8.14a.75.75 0 001.13.63L355.34 305a3.11 3.11 0 001.56-2.67v-8.49a.74.74 0 00-1.09-.67z",
  fill: "url(#hero_svg__linear-gradient-53)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.69 316.84l-37.43 22.21a3.13 3.13 0 00-1.55 2.66v8.14a.74.74 0 001.13.63l37.42-21.85a3.11 3.11 0 001.56-2.67v-8.49a.74.74 0 00-1.13-.63z",
  fill: "url(#hero_svg__linear-gradient-54)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.57 340.51l-37.43 22.21a3.14 3.14 0 00-1.55 2.66v8.14a.74.74 0 001.13.63l37.38-21.85a3.11 3.11 0 001.56-2.67v-8.49a.74.74 0 00-1.09-.63z",
  fill: "url(#hero_svg__linear-gradient-55)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.45 364.18L318 386.39a3.14 3.14 0 00-1.55 2.66v8.14a.74.74 0 001.13.63L355 376a3.11 3.11 0 001.56-2.67v-8.49a.74.74 0 00-1.11-.66z",
  fill: "url(#hero_svg__linear-gradient-56)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-57)",
  d: "M295.63 304.86l.05-2 86.9-51.76.83 1.41-87.78 52.35z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-58)",
  d: "M382.59 253.12l-.01-2.02 243.16-144.83-.32 2.44-242.83 144.41z"
}), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Layer_2-3",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Artwork"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__logo_dark",
  "data-name": "logo dark"
}, /*#__PURE__*/React.createElement("path", {
  d: "M322.72 491.74v-2.48l5.34-3.12v.86c0 3.79-2.06 7.94-4.94 9.62-3 1.78-5.23 0-5.23-3.86s2.21-8.21 5.15-9.93c2-1.17 3.68-.84 4.58.78l.06.09-1.84 2.56-.06-.1c-.59-1.12-1.49-1.33-2.72-.61a7.53 7.53 0 00-3.09 6c0 2.38 1.35 3.41 3.15 2.35a5.89 5.89 0 002.65-3.95z",
  fill: "url(#hero_svg__linear-gradient-59)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333 481.4a1.84 1.84 0 00-.55.23 4.11 4.11 0 00-1.76 2.35v-1.23l-2 1.18v9.13l2.08-1.22v-4a3.73 3.73 0 011.59-3.41 2.71 2.71 0 01.66-.29v-2.74z",
  fill: "url(#hero_svg__linear-gradient-60)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M339.93 481.73c0-2.94-1.3-3.93-3.41-2.69-1.76 1-3.39 3.85-3.39 6.79s1.67 3.89 3.54 2.8a7.09 7.09 0 003.14-4.74l-1.74.36a3 3 0 01-1.37 2c-.81.47-1.51.14-1.55-.86l4.74-2.77c.03-.31.04-.62.04-.89zm-4.73 1.82a3.12 3.12 0 011.36-2.33c1-.58 1.34.06 1.37.74z",
  fill: "url(#hero_svg__linear-gradient-61)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M342.54 484.92v-5.25a2.68 2.68 0 011.12-2.23c.76-.44 1.1 0 1.1.9v5.29l2.05-1.2v-5.27a2.67 2.67 0 011.14-2.23c.74-.43 1.08.05 1.08.91v5.29l2-1.17V474c0-2.48-1.23-2.77-2.52-2a5 5 0 00-2.11 2.67c-.34-.7-1-.82-2-.26a5 5 0 00-1.95 2.47v-1l-2 1.16v9.13z",
  fill: "url(#hero_svg__linear-gradient-62)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-63)",
  d: "M353.82 478.33v-13.3l-2.09 1.22v13.31l2.09-1.23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-64)",
  d: "M356.56 476.73v-9.13l-2.06 1.21v9.12l2.06-1.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M354.33 466.22c0 .91.54 1.33 1.2.94a3 3 0 001.2-2.34c0-.91-.54-1.33-1.2-.94a3 3 0 00-1.2 2.34z",
  fill: "url(#hero_svg__linear-gradient-65)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.33 469.88a2.66 2.66 0 011.12-2.26c.76-.44 1.11 0 1.11.93v5.26l2.08-1.22v-5.73c0-2-.76-3.19-2.47-2.19a4.74 4.74 0 00-1.91 2.4V466l-2 1.18v9.12l2.08-1.21z",
  fill: "url(#hero_svg__linear-gradient-66)"
})))), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-47",
  d: "M411.12 291.93l-2.65 2v3.51l2.65-2zm-.88 3l-.89.68v-1.17l.89-.68z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-47",
  d: "M412.88 289.4c0-.65-.4-.86-.88-.49l-.88.68v-1.17l-.88.68v1.17l-.88.68v-1.18l-.89.68v1.17l-.88.68a2.61 2.61 0 00-.88 1.85v1.17l-.88.68v1.17l.88-.67v1.17l-.88.67v1.18l.88-.68V300c0 .65.39.87.88.49l.88-.68V301l.88-.68v-1.17l.88-.68v1.17l.89-.68v-1.17l.88-.68a2.63 2.63 0 00.88-1.85v-1.17l.88-.68v-1.17l-.88.68v-1.17l.88-.68v-1.17l-.88.68zm-.88 6.54l-4.41 3.39v-5.86l4.41-3.39zm.21 32.36l-.62 1.25c.7.26 1.15 1.07 1.16 2.33a8.29 8.29 0 01-3 6.19c-1.71 1.19-3.09.34-3.11-1.89a8.17 8.17 0 011.11-3.91l-.63-.38a10.57 10.57 0 00-1.36 4.91c0 2.86 1.81 3.94 4 2.42a10.69 10.69 0 003.91-8c-.05-1.53-.6-2.56-1.46-2.92z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-47",
  d: "M410.07 328.54l-.88.61.05 5.77.88-.62-.05-5.76zm1.72 87.46v-1.55a10.24 10.24 0 001.67-4.82c0-2.16-1.68-2.34-3.75-.39s-3.75 5.3-3.75 7.46c0 1.32.64 1.94 1.67 1.69v1.54l.83-.79v-1.31l.83-.78v1.3l.83-.78v-1.31l.84-.78v1.3zm-3.75.48c-.46.44-.83.4-.83-.08a2.69 2.69 0 01.83-1.66c.46-.44.84-.4.84.08a2.71 2.71 0 01-.88 1.64zm1-.11l.63-1.9.62.72zm1.46-3.12a2.69 2.69 0 01.83-1.65c.46-.44.84-.4.84.08a2.73 2.73 0 01-.84 1.66c-.42.41-.79.37-.79-.11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.65 171.49c-7.6-1.76-36.83 11.69-39.43 23.62a45 45 0 00-.41 9.19l50.93-27.83z",
  fill: "url(#hero_svg__linear-gradient-67)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.19 164.26c-8.11 5.58-16.1 10.09-18.18 16.19s5 13.79 7.52 13.17c1.67-.41-1.33-2.64.1-5.87 1.26 3.15 6.68 4.47 8.33 3.92s-3.69-2.92-2.15-6.14c2.71 2.3 6.3 1.38 6.4.36.07-.72-4.1-1.59-3-4.79 3.37-.64 17.65-4.8 17.52-12.65s-9.2-9.24-16.54-4.19z",
  fill: "url(#hero_svg__linear-gradient-68)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.31 193.11c9-4 17-8.24 23.34-6.9 8 1.7 9.22 12.33 7.72 13.75-.75.71-3.06-3.25-5.61-3 3 2.92 1.19 7.75.31 8.14s-2.15-4-5.37-4.69c.76 3.76-2.55 7.49-3.53 7-.78-.36.76-6-2-6.31 0 0-13.38 12.46-20 8.21s-3.02-12.64 5.14-16.2z",
  fill: "url(#hero_svg__linear-gradient-69)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-83",
  d: "M390.49 145.15a1.07 1.07 0 00-.56.25 32.52 32.52 0 01-14.57 7.08 13.1 13.1 0 00-4 1.34 6.85 6.85 0 00-2.13 2.22c-3.9-3.88-9.58-5.47-16.93-4.71l-1.49.15c-7.35.75-12.59 3.46-15.62 8a7.11 7.11 0 00-2.54-1.74 13.21 13.21 0 00-4.16-.51 32.54 32.54 0 01-15.71-4 1.12 1.12 0 00-.62-.12 1.1 1.1 0 00-.84 1.63c.22.38 1.1 2.11 1.34 2.59 1.07 2.11 4.66 6.37 5.85 11.78.12.52.27 1.12.46 1.72l3.21.15-2.3 2.15a13.31 13.31 0 004.29 5.36l3.48-2.24-1 3.47a12.35 12.35 0 006.4.06 11.3 11.3 0 000 3.81 6.86 6.86 0 003.13 4.42c2.23 1.44 5.61 2.29 10.34 2.59a3 3 0 012.07 1.46c.52 1.16 2.81 1.53 7.16 1.15h.17a18.45 18.45 0 005.44-1.23c.92-.45 1.25-.95 1.34-1.34a3 3 0 011.73-1.86c4.81-1.31 8.05-2.92 9.9-4.91a6.64 6.64 0 001.85-5.16v-.1a24.2 24.2 0 00-.7-3.17 15.28 15.28 0 002.53-.14l-.77-3.21 2.53 2.65v-1.92l1.57 1.37a10.2 10.2 0 004.15-4.31l-4-2.74 4.89.61a14.76 14.76 0 00.95-4.49l-2.24-.84s2.36-.59 2.35-.6l-3.24-1.19 3.28-.3c.51-4.85 2.73-9 3.29-11 .14-.5.66-2.34.8-2.77a1.15 1.15 0 00.07-.49 1.11 1.11 0 00-1.15-.92z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.49 145.15a1.07 1.07 0 00-.56.25 32.52 32.52 0 01-14.57 7.08 13.1 13.1 0 00-4 1.34 6.85 6.85 0 00-2.13 2.22c-3.9-3.88-9.58-5.47-16.93-4.71l-1.49.15c-7.35.75-12.59 3.46-15.62 8a7.11 7.11 0 00-2.54-1.74 13.21 13.21 0 00-4.16-.51 32.54 32.54 0 01-15.71-4 1.12 1.12 0 00-.62-.12 1.1 1.1 0 00-.84 1.63c.22.38 1.1 2.11 1.34 2.59 1.07 2.11 4.66 6.37 5.85 11.78.12.52.27 1.12.46 1.72l3.21.15-2.3 2.15a13.31 13.31 0 004.29 5.36l3.48-2.24-1 3.47a12.35 12.35 0 006.4.06 11.3 11.3 0 000 3.81 6.86 6.86 0 003.13 4.42c2.23 1.44 5.61 2.29 10.34 2.59a3 3 0 012.07 1.46c.52 1.16 2.81 1.53 7.16 1.15h.17a18.45 18.45 0 005.44-1.23c.92-.45 1.25-.95 1.34-1.34a3 3 0 011.73-1.86c4.81-1.31 8.05-2.92 9.9-4.91a6.64 6.64 0 001.85-5.16v-.1a24.2 24.2 0 00-.7-3.17 15.28 15.28 0 002.53-.14l-.77-3.21 2.53 2.65v-1.92l1.57 1.37a10.2 10.2 0 004.15-4.31l-4-2.74 4.89.61a14.76 14.76 0 00.95-4.49l-2.24-.84s2.36-.59 2.35-.6l-3.24-1.19 3.28-.3c.51-4.85 2.73-9 3.29-11 .14-.5.66-2.34.8-2.77a1.15 1.15 0 00.07-.49 1.11 1.11 0 00-1.15-.92z",
  fill: "url(#hero_svg__linear-gradient-70)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M380.52 156.08c-4.08 2.21-7.27 4.32-7.75 7.4s1 7.16 2.28 10.72c.15.4.29.8.41 1.21a16.64 16.64 0 002.55 0l-.77-3.21 2.53 2.65v-1.92l1.57 1.37a10.2 10.2 0 004.15-4.31l-4-2.74 4.89.61a14.76 14.76 0 00.95-4.49l-2.24-.84s2.36-.59 2.35-.6l-3.24-1.19 3.28-.3c.51-4.85 2.73-9 3.29-11 .14-.5.66-2.34.8-2.77-2.79 5.03-6.95 7.19-11.05 9.41zm-26.69-1.37c.54-.47 3.26-.41 3.26-.41.64 0 1.12.46.81.8a3.63 3.63 0 01-2.76.82c-1.34-.13-1.86-.75-1.31-1.21zm.05 2.55c1.52-.08.85 1.52 0 1.79s-2.33-.05-2.21-.64 1.46-1.11 2.24-1.15zm-4.99-2.33a3 3 0 012.7 1.3c.18.61-.56 1-2.42 1.41s-3.68-.26-3.73-.78 2.36-1.71 3.45-1.93zm-15.66 12.62c-.84-1.5-1.82-3.71-7-5h-.09a28.42 28.42 0 01-6.13-1.84 31.39 31.39 0 01-8.77-5.84c.22.38 1.1 2.11 1.34 2.59 1.07 2.11 4.66 6.37 5.85 11.78.12.52.27 1.12.46 1.72l3.21.15-2.3 2.15a13.31 13.31 0 004.29 5.36l3.48-2.24-1 3.47a11.08 11.08 0 006.41 0c.06-.42.13-.83.2-1.22.67-3.52 1.57-8.34.05-11.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M367.92 175.42c0 1.72-1.05 2.79-4.23 3.1-.38 0-.78.06-1.22.07-3.44.1-5-.24-8.69.12s-5.16 1-8.55 1.52c-.44.08-.84.12-1.22.16-3.17.3-4.43-.54-4.74-2.24-2.39 2.37 1.24 5.11 3.92 6.15s6 1.39 10.71 1.08l1-.1c4.66-.59 7.88-1.55 10.33-3.08 2.4-1.49 5.48-4.88 2.68-6.77z",
  fill: "url(#hero_svg__linear-gradient-71)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M341.17 182.54c-.84-.59-2.15-1.64-2.06-2.81a.08.08 0 01.14 0A3.78 3.78 0 00342 181a.08.08 0 01.06.12l-.8 1.36a.08.08 0 01-.11 0zm2.04 1.11a10 10 0 01-1.35-.68.1.1 0 010-.15l.85-1.49a.08.08 0 01.14 0l.56 2.16c0 .13 0 .19-.16.14zm.79-.04l-.59-2.29a.22.22 0 01.21-.28h.42c.38 0 .8-.08 1.26-.17h.1a.23.23 0 01.24.35l-1.5 2.46a.08.08 0 01-.14 0zm4.13 1.15a20.06 20.06 0 01-3.15-.53.31.31 0 01-.18-.46l1.76-2.9a.07.07 0 01.13 0l1.74 3.44a.31.31 0 01-.3.45zm1.08-.21l-1.84-3.69a.31.31 0 01.21-.44l1.21-.26c.72-.16 1.41-.31 2.18-.45a.23.23 0 01.25.31l-1.87 4.53a.08.08 0 01-.14 0zm4.1.25c-1 .06-2 .08-2.94.07a.3.3 0 01-.28-.42l1.6-3.94a.08.08 0 01.14 0l1.74 3.86a.3.3 0 01-.26.43zm1.08-.46a.08.08 0 01-.15 0l-2-4.45a.3.3 0 01.24-.43c.42-.05.87-.11 1.37-.15l1.37-.11a.31.31 0 01.32.38l-1.14 4.75zm3.88-.22c-.9.18-1.87.35-2.91.49a.31.31 0 01-.34-.38l1-4.12a.08.08 0 01.14 0l2.31 3.56a.31.31 0 01-.19.47zm.94-.51l-2.7-4.09a.23.23 0 01.19-.36h3.56a.24.24 0 01.22.3l-1.14 4.07a.07.07 0 01-.13 0zm4.22-1.13a19.91 19.91 0 01-3 1.11.31.31 0 01-.38-.38l1.06-3.71a.07.07 0 01.13 0l2.28 2.52a.31.31 0 01-.1.49zm.97-3.15l-.14 2.36a.08.08 0 01-.14 0l-1.93-2.14a.22.22 0 01.16-.38h.1a11.65 11.65 0 001.27-.08h.42a.22.22 0 01.26.24zm1.87 1.32a10.71 10.71 0 01-1.21.92c-.1.07-.18 0-.17-.1l.13-2.23a.08.08 0 01.14-.05l1.12 1.3a.12.12 0 010 .16zm1.03-1.02a6 6 0 01-.42.46.08.08 0 01-.11 0l-1-1.2a.07.07 0 010-.12 4.71 4.71 0 001.62-.79 2.77 2.77 0 00.85-1c0-.06.13-.05.14 0a1.33 1.33 0 01.05.4 3.94 3.94 0 01-1.12 2.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M337.11 167.77c2.49-.32 5.89 2.2 10.84 3.63 1.8.52 3.73.89 4 .94a21.16 21.16 0 01-2.79.61 5.59 5.59 0 01-4.81 3.25 5 5 0 01-5.73-3.71 6.06 6.06 0 01-.26-1.79 14.58 14.58 0 014.63.07 13.53 13.53 0 00-5.17-1.27 7.59 7.59 0 00-2.48.61s.24-2.17 1.76-2.34zm22.04 2.6c4.6-2.33 7.45-5.45 10-5.61 1.52-.1 2.15 2 2.15 2a7.23 7.23 0 00-2.54-.15 13.58 13.58 0 00-4.83 2.22 14.3 14.3 0 014.54-.94 6.44 6.44 0 01.07 1.81 5 5 0 01-4.93 4.72 5.59 5.59 0 01-5.33-2.29 19.86 19.86 0 01-2.86-.08c.27-.1 2.09-.82 3.77-1.67"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M363.88 168.84a14.27 14.27 0 014.53-.94 6.38 6.38 0 01.07 1.8 5 5 0 01-4.91 4.73 5.59 5.59 0 01-5.33-2.3 33.2 33.2 0 005.64-3.29zm-14.7 4.16a5.6 5.6 0 01-4.8 3.26 5 5 0 01-5.72-3.72 6.35 6.35 0 01-.26-1.79 14.53 14.53 0 014.62.07 32.75 32.75 0 006.16 2.18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-25",
  d: "M347.25 173.84c.07-1-5.2-1.74-5.2-1.74-1.69-.45-1.48.59-1.13 1.09s1.47 2.29 3.07 2.37 3.2-1.06 3.26-1.72zm19.32-3.05c-.22.56-1.05 2.41-2.58 2.9s-3.24-.15-3.51-1.07 4.77-2.69 4.77-2.69c.69-.28 1.88-.57 1.32.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M345.2 172.82s1.71.26 1.82 1-2.54-.64-3.19-.84-.09-.52 1.37-.17zm17.07-1.59s-1.64.58-1.6 1.33 2.37-1.09 3-1.42 0-.53-1.38.09z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-72)",
  d: "M626.14 253.77v35.8l18.05-14.52 1.33-15.16-19.38-6.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M625.73 283.61l.06 16.56 2.58 2s-6 10.16-3.59 14.94 9.23 6.83 9.23 6.83l-1-4.44 5.13 1-1.37-3.76 5.12-.34-6.89-4.1s15.37-13.67 7.17-21.86a24.19 24.19 0 00-16.44-6.83z",
  fill: "url(#hero_svg__linear-gradient-73)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.94 260c-17.18-4.82-15.37 18.78-15.37 18.78s-6.29-10.48-11.5-11.68-10.26 7.32-10.26 7.32l4.86-.41-3.14 5.89 5.17-1.39.44 6.81 5.24-5.59s2.52 17.72 9 17 27.71-33.29 15.56-36.73z",
  fill: "url(#hero_svg__linear-gradient-74)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-83",
  d: "M674.67 238a1.1 1.1 0 00-.57 0 30.4 30.4 0 01-15.1.3 12.45 12.45 0 00-3.89-.41 6.59 6.59 0 00-2.67 1.05c-1.78-4.81-6-8.37-12.49-10.6l-1.32-.45c-6.52-2.23-12-2-16.37.71a6.37 6.37 0 00-1.46-2.46 12.19 12.19 0 00-3.32-2.06 30.26 30.26 0 01-11.75-9.5 1 1 0 00-.48-.34 1 1 0 00-.7 0 1 1 0 00-.64 1c0 .41.1 2.22.12 2.72.08 2.2 1.46 7.21.35 12.25-.1.48-.2 1.06-.28 1.64l2.66 1.38-2.79.92a12.26 12.26 0 001.54 6.21l3.82-.53-2.22 2.53a11.35 11.35 0 005.4 2.55 10.57 10.57 0 00-1.46 3.24 6.34 6.34 0 00.92 5c1.32 2.1 3.86 4.14 7.74 6.23a2.78 2.78 0 011.18 2c0 1.2 1.79 2.4 5.62 3.77h.16a17.41 17.41 0 005.08 1.08 2.06 2.06 0 001.66-.61 2.8 2.8 0 012.19-.9c4.58.77 8 .67 10.3-.3a6.18 6.18 0 003.58-3.64v-.09a21.38 21.38 0 00.64-3 13.42 13.42 0 002.2.87l.6-3 1.11 3.23.78-1.62.79 1.78a9.54 9.54 0 005.2-2l-2.31-3.88 3.9 2.42a14 14 0 002.56-3.43l-1.57-1.58 2.23.4-2.28-2.26 2.9 1c2.32-3.91 5.81-6.54 7.08-8 .31-.37 1.47-1.72 1.75-2a1 1 0 00.25-.39 1 1 0 00-.64-1.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.67 238a1.1 1.1 0 00-.57 0 30.4 30.4 0 01-15.1.3 12.45 12.45 0 00-3.89-.41 6.59 6.59 0 00-2.67 1.05c-1.78-4.81-6-8.37-12.49-10.6l-1.32-.45c-6.52-2.23-12-2-16.37.71a6.37 6.37 0 00-1.46-2.46 12.19 12.19 0 00-3.32-2.06 30.26 30.26 0 01-11.75-9.5 1 1 0 00-.48-.34 1 1 0 00-.7 0 1 1 0 00-.64 1c0 .41.1 2.22.12 2.72.08 2.2 1.46 7.21.35 12.25-.1.48-.2 1.06-.28 1.64l2.66 1.38-2.79.92a12.26 12.26 0 001.54 6.21l3.82-.53-2.22 2.53a11.35 11.35 0 005.4 2.55 10.57 10.57 0 00-1.46 3.24 6.34 6.34 0 00.92 5c1.32 2.1 3.86 4.14 7.74 6.23a2.78 2.78 0 011.18 2c0 1.2 1.79 2.4 5.62 3.77h.16a17.41 17.41 0 005.08 1.08 2.06 2.06 0 001.66-.61 2.8 2.8 0 012.19-.9c4.58.77 8 .67 10.3-.3a6.18 6.18 0 003.58-3.64v-.09a21.38 21.38 0 00.64-3 13.42 13.42 0 002.2.87l.6-3 1.11 3.23.78-1.62.79 1.78a9.54 9.54 0 005.2-2l-2.31-3.88 3.9 2.42a14 14 0 002.56-3.43l-1.57-1.58 2.23.4-2.28-2.26 2.9 1c2.32-3.91 5.81-6.54 7.08-8 .31-.37 1.47-1.72 1.75-2a1 1 0 00.25-.39 1 1 0 00-.64-1.23z",
  fill: "url(#hero_svg__linear-gradient-75)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M662 243.33c-4.31.28-7.84.82-9.45 3.24s-1.92 6.46-2.25 10c0 .4-.08.79-.13 1.18a14.42 14.42 0 002.18.95l.6-3 1.11 3.23.78-1.62.79 1.78a9.54 9.54 0 005.2-2l-2.31-3.88 3.9 2.42a14 14 0 002.56-3.43l-1.57-1.58 2.23.4-2.28-2.26 2.9 1c2.32-3.91 5.81-6.54 7.08-8 .31-.37 1.47-1.72 1.75-2-4.42 3.09-8.79 3.3-13.09 3.57zm-22.1-11.58c.64-.18 2.92.93 2.92.93.53.27.77.82.37 1a3.33 3.33 0 01-2.65-.38c-1.09-.63-1.29-1.36-.64-1.54zm-.9 2.18c1.32.53.13 1.62-.73 1.51s-2-1-1.62-1.41 1.67-.37 2.35-.1zm-3.37-3.93a2.78 2.78 0 011.78 2.16c-.08.58-.85.58-2.6.25s-3-1.66-2.85-2.12 2.66-.53 3.67-.29zm-18.19 4.58c-.12-1.6-.09-3.84-3.92-7l-.06-.05a27.73 27.73 0 01-4.48-3.95 29.4 29.4 0 01-5.13-8.37c0 .41.1 2.22.12 2.72.08 2.2 1.46 7.21.35 12.25-.1.48-.2 1.06-.28 1.64l2.66 1.38-2.79.92a12.26 12.26 0 001.54 6.21l3.82-.53-2.22 2.53a10.32 10.32 0 005.41 2.55c.21-.33.43-.66.64-1 1.9-2.66 4.57-6.39 4.34-9.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.74 254.79c-.65 1.46-2 2-4.78 1-.34-.12-.69-.26-1.07-.42-2.95-1.25-4.12-2.14-7.4-3.29s-4.75-1.18-7.84-2.05a10.87 10.87 0 01-1.09-.34c-2.8-1-3.54-2.18-3.13-3.75-2.95 1.08-.95 4.82.91 6.74s4.56 3.53 8.65 5.1l.9.31c4.18 1.32 7.28 1.76 9.94 1.43 2.61-.33 6.55-2 4.91-4.69z",
  fill: "url(#hero_svg__linear-gradient-76)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M618.32 250.37c-.48-.82-1.18-2.23-.65-3.18a.08.08 0 01.14 0 3.53 3.53 0 001.81 2.21.07.07 0 010 .12l-1.2.85a.07.07 0 01-.11 0zm1.29 1.74a11.78 11.78 0 01-.88-1.1.11.11 0 010-.15l1.3-.92a.07.07 0 01.11.07l-.37 2c0 .12-.11.14-.19.06zm.71.28l.39-2.16a.21.21 0 01.29-.16l.37.13a10.39 10.39 0 001.14.35h.09a.21.21 0 01.06.38l-2.23 1.5a.07.07 0 01-.11-.07zm3.02 2.61a18.69 18.69 0 01-2.45-1.68.29.29 0 010-.46l2.62-1.77a.07.07 0 01.11.05l.13 3.6a.29.29 0 01-.43.26zm1 .21l-.12-3.84a.29.29 0 01.35-.29l1.13.25c.67.15 1.31.29 2 .47a.21.21 0 01.09.36l-3.35 3.1a.07.07 0 01-.12 0zm3.37 1.79c-.9-.36-1.74-.73-2.51-1.1a.28.28 0 01-.08-.46l2.89-2.71a.07.07 0 01.12.05v3.95a.3.3 0 01-.4.27zm1.09.06a.07.07 0 01-.12-.05v-4.55a.3.3 0 01.37-.28l1.22.41c.44.15.83.3 1.2.44a.29.29 0 01.12.45l-2.82 3.58zm3.38 1.32c-.84-.19-1.72-.43-2.65-.72a.28.28 0 01-.14-.45l2.44-3.1a.07.07 0 01.13 0l.56 3.92a.28.28 0 01-.34.32zm.99-.06l-.68-4.52a.21.21 0 01.3-.22c.66.29 1.26.59 1.87.89l1.12.55a.22.22 0 01.07.33l-2.56 3a.07.07 0 01-.12 0zm4.02.68a18.52 18.52 0 01-3-.23.29.29 0 01-.18-.47l2.35-2.72a.07.07 0 01.12 0l.94 3a.28.28 0 01-.27.37zm2.05-2.28l-1 1.94a.08.08 0 01-.14 0l-.8-2.57a.21.21 0 01.29-.26h.08c.4.18.78.31 1.11.43l.38.13a.21.21 0 01.12.3zm1.06 1.85a11 11 0 01-1.38.31c-.11 0-.16-.06-.11-.16l1-1.83a.07.07 0 01.13 0l.44 1.54a.1.1 0 01-.07.13zm1.27-.46l-.53.23a.09.09 0 01-.1 0l-.41-1.42a.07.07 0 01.08-.09 4.66 4.66 0 001.68 0 2.79 2.79 0 001.13-.56.07.07 0 01.11.07 1.75 1.75 0 01-.11.35 3.75 3.75 0 01-1.85 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M620.64 236.28c2.24.7 4.14 4.17 7.76 7.31 1.33 1.14 2.82 2.2 3 2.36a19.23 19.23 0 01-2.6-.58 5.19 5.19 0 01-5.34.88 4.68 4.68 0 01-3.4-5.38 5.71 5.71 0 01.48-1.62 13.41 13.41 0 013.89 1.87 12.45 12.45 0 00-3.88-3.09 6.71 6.71 0 00-2.34-.45s1-1.74 2.4-1.3zm27.23 11.35a12.38 12.38 0 00-5 0 13.6 13.6 0 014.21 1 6.25 6.25 0 01-.64 1.56 4.7 4.7 0 01-6 2.08 5.25 5.25 0 01-3.63-4 20.56 20.56 0 01-2.38-1.17c.27 0 2.09.11 3.84 0 4.81-.17 8.43-1.7 10.62-.85 1.33.51 1.05 2.51 1.05 2.51a6.79 6.79 0 00-2.09-1.11z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M642.89 247.64a13.21 13.21 0 014.2 1 5.9 5.9 0 01-.64 1.56 4.68 4.68 0 01-6 2.08 5.2 5.2 0 01-3.61-4 32.26 32.26 0 006.06-.59zm-14.05-2.25a5.2 5.2 0 01-5.34.88 4.68 4.68 0 01-3.39-5.38 5.81 5.81 0 01.48-1.62 13.68 13.68 0 013.88 1.87 31.48 31.48 0 004.37 4.25z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-25",
  d: "M626.86 245.38c.44-.78-3.72-3.51-3.72-3.51-1.26-1-1.49-.07-1.39.49s.36 2.51 1.68 3.2 3.12.36 3.43-.18zm17.55 4.96c-.41.39-1.83 1.64-3.32 1.45s-2.68-1.39-2.55-2.28 5.09-.41 5.09-.41c.69.03 1.81.25.78 1.24z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-3",
  d: "M625.52 243.72s1.35.88 1.15 1.56-1.9-1.53-2.38-2 .13-.47 1.23.4zm15.07 5.28s-1.61-.16-1.87.5 2.43 0 3.08 0 .19-.46-1.21-.46z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542.66 408.82c-.15 10.36 6.64 20.71 20.27 28.58 27.16 15.68 71.33 15.58 98.69-.2 13.63-7.86 20.47-18.12 20.61-28.38v-26.77H542.66z",
  fill: "url(#hero_svg__linear-gradient-77)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.93 410.63c27.16 15.68 71.33 15.58 98.69-.2s27.5-41.28.34-57-71.33-15.59-98.69.19-27.5 41.38-.34 57.01z",
  fill: "url(#hero_svg__radial-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.93 423.28c-18 0-35.91-3.91-49.49-11.82-9.62-5.57-16.22-12.56-19.1-20.28l1.86-.68c2.73 7.28 9 13.92 18.27 19.25 26.82 15.48 70.69 15.39 97.71-.2 7.67-4.44 13.48-9.87 16.75-15.73l1.71 1c-3.51 6.25-9.42 11.77-17.49 16.46-13.92 8-32.09 12-50.22 12z",
  fill: "url(#hero_svg__linear-gradient-78)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M566.15 407.55c25.41 14.36 66.69 14.26 92.24-.2s25.7-37.86.34-52.22-66.68-14.27-92.23.19-25.75 37.87-.35 52.23z",
  fill: "url(#hero_svg__linear-gradient-79)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550.86 369.39v-35.61H674v59.5c-3.18 5.13-8.36 10-15.64 14.07-25.55 14.46-66.88 14.56-92.24.2-7.08-4-12.16-8.75-15.29-13.78v-24.38z",
  fill: "url(#hero_svg__linear-gradient-80)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M568.74 359c23.94 13.82 62.93 13.77 87.06-.2s24.28-36.44.3-50.27-62.93-13.78-87.06.2-24.28 36.43-.3 50.27z",
  fill: "url(#hero_svg__radial-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M612 370.27c-15.88 0-31.71-3.47-43.72-10.4-8.51-4.89-14.37-11.09-16.91-17.93l1.86-.69c2.39 6.4 8 12.27 16.07 16.91 23.65 13.68 62.29 13.58 86.08-.2 6.75-3.91 11.88-8.69 14.76-13.82l1.71 1c-3.13 5.52-8.36 10.46-15.49 14.56-12.26 7.09-28.33 10.6-44.36 10.6z",
  fill: "url(#hero_svg__linear-gradient-81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.48 355.23c21.35 12.11 56.09 12 77.58-.15s21.65-31.85.25-43.92-56.09-12-77.58.14-21.6 31.81-.25 43.93z",
  fill: "url(#hero_svg__linear-gradient-82)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-29",
  d: "M573.48 355.23a42 42 0 01-7.48-5.33 50.07 50.07 0 017.77-5.57c21.49-12.16 56.23-12.26 77.58-.15a42 42 0 017.52 5.33 50.07 50.07 0 01-7.77 5.57c-21.53 12.16-56.27 12.21-77.62.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.69 308.67a173.56 173.56 0 00-3.62-25.16c-9.92-8-23.25-15.3-41.23-20.62 26.09 16 38.74 33.42 44.85 45.78z",
  fill: "url(#hero_svg__linear-gradient-83)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.73 329.28a160 160 0 000-18.95.17.17 0 000-.1c-5.81-12.31-18.36-30.34-45.33-46.85 2.88 3.08 12.75 14.8 20 37a103.39 103.39 0 0125.33 28.9z",
  fill: "url(#hero_svg__linear-gradient-84)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M548.57 262.5c.44.14.83.24 1.27.39-.69-.39-1.37-.83-2.06-1.22a.3.3 0 00-.43.1.32.32 0 00.09.44l1.91 1.17c-.49-.59-.78-.88-.78-.88z",
  fill: "url(#hero_svg__linear-gradient-85)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.73 310.23a.17.17 0 000 .1c0-.54 0-1.13-.09-1.66-6.11-12.36-18.76-29.76-44.85-45.78-.44-.15-.83-.25-1.27-.39l.83.83c27.02 16.56 39.57 34.54 45.38 46.9z",
  fill: "url(#hero_svg__linear-gradient-86)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.73 310.23a.17.17 0 000 .1c0-.54 0-1.13-.09-1.66-6.11-12.36-18.76-29.76-44.85-45.78-.44-.15-.83-.25-1.27-.39l.83.83c27.02 16.56 39.57 34.54 45.38 46.9z",
  fill: "url(#hero_svg__linear-gradient-87)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M610.56 306.22a115.65 115.65 0 00-10.94-30.14 99.76 99.76 0 00-19.44-25.8 161.37 161.37 0 0110.89 33.23 78.26 78.26 0 0119.49 22.71z",
  fill: "url(#hero_svg__linear-gradient-88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600.16 275.74a118.41 118.41 0 0111.48 32.39 65.21 65.21 0 013.71 8.3c1.86-3.51 3.76-6.84 5.67-9.91-6.11-18-17.78-40.26-39.92-56.28a102.47 102.47 0 0119.06 25.5z",
  fill: "url(#hero_svg__linear-gradient-89)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.14 344.28l-1.32.34.58 1.76c.2-.73.49-1.38.74-2.1z",
  fill: "url(#hero_svg__linear-gradient-90)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M615.3 316.43a70.45 70.45 0 00-3.71-8.3c.73 3.81 1.37 7.77 1.81 12 .63-1.22 1.27-2.49 1.9-3.67z",
  fill: "url(#hero_svg__linear-gradient-91)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M615.3 316.43a70.45 70.45 0 00-3.71-8.3c.73 3.81 1.37 7.77 1.81 12 .63-1.22 1.27-2.49 1.9-3.67z",
  fill: "url(#hero_svg__linear-gradient-92)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595.32 310c6.5 13.77 6.21 23.69 6.21 23.84a.32.32 0 01-.3.29c-.19 0-.29-.15-.29-.34s.24-9.87-6.11-23.45a153.8 153.8 0 01-.05 18.95 84.83 84.83 0 017 15.34l1.32-.34a218.49 218.49 0 019.77-23.11 132.4 132.4 0 00-2.3-15 78.91 78.91 0 00-19.49-22.71 171.26 171.26 0 013.61 25.16 13.13 13.13 0 00.59 1.37z",
  fill: "url(#hero_svg__linear-gradient-93)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M595.32 310c6.5 13.77 6.21 23.69 6.21 23.84a.32.32 0 01-.3.29c-.19 0-.29-.15-.29-.34s.24-9.87-6.11-23.45a153.8 153.8 0 01-.05 18.95 84.83 84.83 0 017 15.34l1.32-.34a218.49 218.49 0 019.77-23.11 132.4 132.4 0 00-2.3-15 78.91 78.91 0 00-19.49-22.71 171.26 171.26 0 013.61 25.16 13.13 13.13 0 00.59 1.37z",
  fill: "url(#hero_svg__linear-gradient-94)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600.89 333.78a.33.33 0 00.29.34.32.32 0 00.3-.29c0-.1.29-10-6.21-23.84-.19-.44-.44-.88-.63-1.32.05.53.05 1.12.09 1.66 6.45 13.58 6.21 23.35 6.16 23.45z",
  fill: "url(#hero_svg__linear-gradient-95)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600.89 333.78a.33.33 0 00.29.34.32.32 0 00.3-.29c0-.1.29-10-6.21-23.84-.19-.44-.44-.88-.63-1.32.05.53.05 1.12.09 1.66 6.45 13.58 6.21 23.35 6.16 23.45z",
  fill: "url(#hero_svg__linear-gradient-96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600.89 333.78a.33.33 0 00.29.34.32.32 0 00.3-.29c0-.1.29-10-6.21-23.84-.19-.44-.44-.88-.63-1.32.05.53.05 1.12.09 1.66 6.45 13.58 6.21 23.35 6.16 23.45z",
  fill: "url(#hero_svg__linear-gradient-97)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581.06 250.24a28.28 28.28 0 00-2.45-2.15.31.31 0 00-.44 0 .31.31 0 00.05.43 25.82 25.82 0 012 1.71c-.3-.68-.49-1-.49-1a12.16 12.16 0 011.37 1z",
  fill: "url(#hero_svg__linear-gradient-98)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599.62 276a116.34 116.34 0 0110.94 30.14c.35.64.74 1.28 1 1.91a116.3 116.3 0 00-11.48-32.39 102.5 102.5 0 00-19.05-25.5 12.77 12.77 0 00-1.42-1s.19.34.49 1A99.08 99.08 0 01599.62 276z",
  fill: "url(#hero_svg__linear-gradient-99)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M599.62 276a116.34 116.34 0 0110.94 30.14c.35.64.74 1.28 1 1.91a116.3 116.3 0 00-11.48-32.39 102.5 102.5 0 00-19.05-25.5 12.77 12.77 0 00-1.42-1s.19.34.49 1A99.08 99.08 0 01599.62 276z",
  fill: "url(#hero_svg__linear-gradient-100)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.59 308.13l-1-1.91a120.56 120.56 0 012.3 15c.2-.34.34-.73.54-1.07-.43-4.25-1.06-8.21-1.84-12.02z",
  fill: "url(#hero_svg__linear-gradient-101)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.59 308.13l-1-1.91a120.56 120.56 0 012.3 15c.2-.34.34-.73.54-1.07-.43-4.25-1.06-8.21-1.84-12.02z",
  fill: "url(#hero_svg__linear-gradient-102)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.59 308.13l-1-1.91a120.56 120.56 0 012.3 15c.2-.34.34-.73.54-1.07-.43-4.25-1.06-8.21-1.84-12.02z",
  fill: "url(#hero_svg__linear-gradient-103)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M651.9 279.94a72.72 72.72 0 0119.1-17.3c-6.21 1.71-29 10-50 43.88a133.74 133.74 0 016.35 27.84c4.54-19 12.07-38.74 24.58-54.42z",
  fill: "url(#hero_svg__linear-gradient-104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.57 334.41c1-22.91 6.3-55.3 27.26-71.47-20.96 16.17-26.33 48.56-27.26 71.47z",
  fill: "url(#hero_svg__linear-gradient-105)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M612.27 357.57c-.14.93-.29 1.91-.44 2.83a.3.3 0 01-.29.25.34.34 0 01-.24-.39c.14-.88.29-1.71.44-2.59a41.24 41.24 0 01-6.4.83c.29 2.2.49 4 .53 5.47a100.78 100.78 0 0016.66-.34c.44-4.2 1-8.55 1.76-13.09-3 3.81-7.33 5.91-12 7z",
  fill: "url(#hero_svg__linear-gradient-106)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619.55 340l-5.62 1.47a147.14 147.14 0 01-1.66 16.07c4.64-1.12 9-3.22 11.92-7 .83-5.28 1.91-10.75 3.23-16.22a137.81 137.81 0 00-6.35-27.85c-1.91 3.08-3.81 6.4-5.67 9.92 4.89 13.38 4.15 23.59 4.15 23.59z",
  fill: "url(#hero_svg__linear-gradient-107)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M619.55 340l-5.62 1.47a147.14 147.14 0 01-1.66 16.07c4.64-1.12 9-3.22 11.92-7 .83-5.28 1.91-10.75 3.23-16.22a137.81 137.81 0 00-6.35-27.85c-1.91 3.08-3.81 6.4-5.67 9.92 4.89 13.38 4.15 23.59 4.15 23.59z",
  fill: "url(#hero_svg__linear-gradient-108)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.14 344.28c-.25.69-.49 1.37-.74 2.1a74 74 0 012.84 12.22 49.42 49.42 0 006.4-.83 161.38 161.38 0 001.71-16.08l-10.21 2.59z",
  fill: "url(#hero_svg__linear-gradient-109)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.14 344.28c-.25.69-.49 1.37-.74 2.1a74 74 0 012.84 12.22 49.42 49.42 0 006.4-.83 161.38 161.38 0 001.71-16.08l-10.21 2.59z",
  fill: "url(#hero_svg__linear-gradient-110)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M612.86 321.17a218.49 218.49 0 00-9.77 23.11l10.16-2.64a133.43 133.43 0 00-.39-20.47z",
  fill: "url(#hero_svg__linear-gradient-111)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M612.86 321.17a218.49 218.49 0 00-9.77 23.11l10.16-2.64a133.43 133.43 0 00-.39-20.47z",
  fill: "url(#hero_svg__linear-gradient-112)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M612.86 321.17a218.49 218.49 0 00-9.77 23.11l10.16-2.64a133.43 133.43 0 00-.39-20.47z",
  fill: "url(#hero_svg__linear-gradient-113)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.93 341.45l5.62-1.47s.78-10.21-4.2-23.55c-.63 1.23-1.27 2.45-1.9 3.72a143.72 143.72 0 01.48 21.3z",
  fill: "url(#hero_svg__linear-gradient-114)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.93 341.45l5.62-1.47s.78-10.21-4.2-23.55c-.63 1.23-1.27 2.45-1.9 3.72a143.72 143.72 0 01.48 21.3z",
  fill: "url(#hero_svg__linear-gradient-115)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.93 341.45l5.62-1.47s.78-10.21-4.2-23.55c-.63 1.23-1.27 2.45-1.9 3.72a143.72 143.72 0 01.48 21.3z",
  fill: "url(#hero_svg__linear-gradient-116)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.2 360.31c-.05.14.1.34.24.39a.28.28 0 00.3-.25c.14-1 .29-1.9.43-2.83l-.68.15c-.1.78-.19 1.66-.34 2.54z",
  fill: "url(#hero_svg__linear-gradient-117)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.2 360.31c-.05.14.1.34.24.39a.28.28 0 00.3-.25c.14-1 .29-1.9.43-2.83l-.68.15c-.1.78-.19 1.66-.34 2.54z",
  fill: "url(#hero_svg__linear-gradient-118)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.3 341.64a147.79 147.79 0 01-1.71 16.08l.68-.15a147.14 147.14 0 001.66-16.07l-.63.14z",
  fill: "url(#hero_svg__linear-gradient-119)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.3 341.64a147.79 147.79 0 01-1.71 16.08l.68-.15a147.14 147.14 0 001.66-16.07l-.63.14z",
  fill: "url(#hero_svg__linear-gradient-120)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.3 341.64a147.79 147.79 0 01-1.71 16.08l.68-.15a147.14 147.14 0 001.66-16.07l-.63.14z",
  fill: "url(#hero_svg__linear-gradient-121)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.3 341.64l.63-.14a137.6 137.6 0 00-.53-21.35c-.2.34-.34.68-.54 1.07a139 139 0 01.44 20.42z",
  fill: "url(#hero_svg__linear-gradient-122)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.3 341.64l.63-.14a137.6 137.6 0 00-.53-21.35c-.2.34-.34.68-.54 1.07a139 139 0 01.44 20.42z",
  fill: "url(#hero_svg__linear-gradient-123)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.3 341.64l.63-.14a137.6 137.6 0 00-.53-21.35c-.2.34-.34.68-.54 1.07a139 139 0 01.44 20.42z",
  fill: "url(#hero_svg__linear-gradient-124)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.3 341.64l.63-.14a137.6 137.6 0 00-.53-21.35c-.2.34-.34.68-.54 1.07a139 139 0 01.44 20.42z",
  fill: "url(#hero_svg__linear-gradient-125)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.83 262.94c-4.45 2.59-11.78 7.86-19.45 17.44-12.8 16.07-20.37 36.45-24.81 55.89 0 .73.09 1.12.09 1.12.25 5.08-.78 9-2.64 12-.83 4.94-1.46 9.72-1.95 14.22a88.41 88.41 0 0012.65-2.39 102.81 102.81 0 018.85-26.83c.93-22.89 6.3-55.28 27.26-71.45z",
  fill: "url(#hero_svg__linear-gradient-126)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M671.83 262.94c-4.45 2.59-11.78 7.86-19.45 17.44-12.8 16.07-20.37 36.45-24.81 55.89 0 .73.09 1.12.09 1.12.25 5.08-.78 9-2.64 12-.83 4.94-1.46 9.72-1.95 14.22a88.41 88.41 0 0012.65-2.39 102.81 102.81 0 018.85-26.83c.93-22.89 6.3-55.28 27.26-71.45z",
  fill: "url(#hero_svg__linear-gradient-127)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.66 337.39a10.24 10.24 0 00-.09-1.12c-1 4.45-1.86 8.79-2.55 13.09 1.86-2.98 2.89-6.89 2.64-11.97z",
  fill: "url(#hero_svg__linear-gradient-128)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.66 337.39a10.24 10.24 0 00-.09-1.12c-1 4.45-1.86 8.79-2.55 13.09 1.86-2.98 2.89-6.89 2.64-11.97z",
  fill: "url(#hero_svg__linear-gradient-129)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.66 337.39a10.24 10.24 0 00-.09-1.12c-1 4.45-1.86 8.79-2.55 13.09 1.86-2.98 2.89-6.89 2.64-11.97z",
  fill: "url(#hero_svg__linear-gradient-130)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M544.41 294c0-.05-.09-.1-.09-.15s.05.15.09.15z",
  fill: "url(#hero_svg__linear-gradient-131)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535.86 284z",
  fill: "url(#hero_svg__linear-gradient-132)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.27 337.74l-.14-.88z",
  fill: "url(#hero_svg__linear-gradient-133)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535.23 283.41c0-.05-.05-.05 0 0s0-.05 0 0z",
  fill: "url(#hero_svg__linear-gradient-134)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541.19 289.91c-.05-.05-.1-.15-.15-.2a.69.69 0 00.15.2z",
  fill: "url(#hero_svg__linear-gradient-135)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.79 348.78v-.69c-.05.25 0 .44 0 .69z",
  fill: "url(#hero_svg__linear-gradient-136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M540.41 289c0-.05-.1-.15-.15-.2s.1.13.15.2z",
  fill: "url(#hero_svg__linear-gradient-137)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.59 346.82c-.05-.34-.05-.73-.1-1.07a7.74 7.74 0 01.1 1.07z",
  fill: "url(#hero_svg__linear-gradient-138)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.35 344.48l-.15-1z",
  fill: "url(#hero_svg__linear-gradient-139)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542 290.88c0-.05-.1-.14-.15-.19a.63.63 0 00.15.19z",
  fill: "url(#hero_svg__linear-gradient-140)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.66 339.93c0-.29-.09-.63-.14-.92.05.29.09.63.14.92z",
  fill: "url(#hero_svg__linear-gradient-141)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.63 288.1a.69.69 0 01-.15-.2.69.69 0 01.15.2z",
  fill: "url(#hero_svg__linear-gradient-142)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537.33 285.56c-.05-.05-.1-.1-.1-.15s.1.1.1.15z",
  fill: "url(#hero_svg__linear-gradient-143)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.65 284.83l-.1-.1z",
  fill: "url(#hero_svg__linear-gradient-144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538.11 286.39l-.14-.15z",
  fill: "url(#hero_svg__linear-gradient-145)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542.8 291.91a2.43 2.43 0 01-.14-.2 2.43 2.43 0 00.14.2z",
  fill: "url(#hero_svg__linear-gradient-146)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538.84 287.22l-.14-.15s.1.1.14.15z",
  fill: "url(#hero_svg__linear-gradient-147)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559.66 323.52a3.83 3.83 0 00-.25-.69 3.83 3.83 0 01.25.69z",
  fill: "url(#hero_svg__linear-gradient-148)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560.29 325.42c0-.24-.14-.48-.19-.68a4.44 4.44 0 00.19.68z",
  fill: "url(#hero_svg__linear-gradient-149)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 342.18c0-.34-.09-.63-.14-1a3.36 3.36 0 01.14 1z",
  fill: "url(#hero_svg__linear-gradient-150)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554 309.69c0-.05 0-.14-.1-.19s.1.14.1.19z",
  fill: "url(#hero_svg__linear-gradient-151)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554.82 311.3a1.88 1.88 0 01-.15-.34 2.84 2.84 0 01.15.34z",
  fill: "url(#hero_svg__linear-gradient-152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560.88 327.38c0-.25-.15-.49-.2-.73a4.2 4.2 0 00.2.73z",
  fill: "url(#hero_svg__linear-gradient-153)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545.24 295.08s0-.09-.09-.14.05.06.09.14z",
  fill: "url(#hero_svg__linear-gradient-154)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555.55 312.92a1.28 1.28 0 00-.19-.39.89.89 0 01.19.39z",
  fill: "url(#hero_svg__linear-gradient-155)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559.07 321.66c-.1-.19-.15-.44-.24-.63a5.22 5.22 0 00.24.63z",
  fill: "url(#hero_svg__linear-gradient-156)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M557 316.29a4.92 4.92 0 00-.2-.49 4.92 4.92 0 01.2.49z",
  fill: "url(#hero_svg__linear-gradient-157)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556.29 314.58c0-.15-.15-.3-.2-.44a1.58 1.58 0 01.2.44z",
  fill: "url(#hero_svg__linear-gradient-158)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558.39 319.81c-.1-.2-.15-.4-.25-.59a2.75 2.75 0 01.25.59z",
  fill: "url(#hero_svg__linear-gradient-159)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.42 329.38c0-.24-.15-.49-.2-.78.05.24.15.49.2.78z",
  fill: "url(#hero_svg__linear-gradient-160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.44 333.44c-.05-.3-.15-.54-.19-.83a3.6 3.6 0 00.19.83z",
  fill: "url(#hero_svg__linear-gradient-161)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546 296.21v-.1.1z",
  fill: "url(#hero_svg__linear-gradient-162)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562 331.38c-.05-.24-.14-.53-.19-.78a5.22 5.22 0 00.19.78z",
  fill: "url(#hero_svg__linear-gradient-163)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.88 335.59a4.61 4.61 0 00-.19-.83c.04.24.14.53.19.83z",
  fill: "url(#hero_svg__linear-gradient-164)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553.26 308.13v-.05z",
  fill: "url(#hero_svg__linear-gradient-165)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.14 357.57c1-3.52 1.76-7 2.4-10.5l-15.1 3.93c-.44-20.76-3.81-37.52-8.06-50.61-10.07-8.06-22.87-15.73-39.13-22.38 25.11 14.17 36.54 37.62 41.72 55.11a135.5 135.5 0 014.64 23.7 73.68 73.68 0 0020.57 6.25c.44-1.51.88-3 1.32-4.49a76.51 76.51 0 01-8.36-1z",
  fill: "url(#hero_svg__linear-gradient-166)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592.54 347a143.89 143.89 0 002.19-17.79 103.66 103.66 0 00-25.35-28.87c4.25 13.09 7.57 29.8 8.06 50.61z",
  fill: "url(#hero_svg__linear-gradient-167)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592.54 347a143.89 143.89 0 002.19-17.79 103.66 103.66 0 00-25.35-28.87c4.25 13.09 7.57 29.8 8.06 50.61z",
  fill: "url(#hero_svg__linear-gradient-168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601.82 344.62l-9.28 2.4c-.64 3.47-1.47 7-2.4 10.5a59.58 59.58 0 008.31 1q1.9-6.37 3.95-12.17c-.19-.53-.39-1.12-.58-1.71z",
  fill: "url(#hero_svg__linear-gradient-169)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601.82 344.62l-9.28 2.4c-.64 3.47-1.47 7-2.4 10.5a59.58 59.58 0 008.31 1q1.9-6.37 3.95-12.17c-.19-.53-.39-1.12-.58-1.71z",
  fill: "url(#hero_svg__linear-gradient-170)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.73 329.28a155.5 155.5 0 01-2.19 17.79l9.28-2.4a86 86 0 00-7.09-15.39z",
  fill: "url(#hero_svg__linear-gradient-171)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.73 329.28a155.5 155.5 0 01-2.19 17.79l9.28-2.4a86 86 0 00-7.09-15.39z",
  fill: "url(#hero_svg__linear-gradient-172)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.73 329.28a155.5 155.5 0 01-2.19 17.79l9.28-2.4a86 86 0 00-7.09-15.39z",
  fill: "url(#hero_svg__linear-gradient-173)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598.45 358.55c-.44 1.46-.88 3-1.32 4.49 2.83.44 5.71.78 8.65 1-.1-1.47-.25-3.27-.54-5.47a64 64 0 01-6.79-.02z",
  fill: "url(#hero_svg__linear-gradient-174)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598.45 358.55c-.44 1.46-.88 3-1.32 4.49 2.83.44 5.71.78 8.65 1-.1-1.47-.25-3.27-.54-5.47a64 64 0 01-6.79-.02z",
  fill: "url(#hero_svg__linear-gradient-175)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598.45 358.55a64 64 0 006.79 0 74 74 0 00-2.84-12.22c-1.36 3.91-2.68 8-3.95 12.22z",
  fill: "url(#hero_svg__linear-gradient-176)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598.45 358.55a64 64 0 006.79 0 74 74 0 00-2.84-12.22c-1.36 3.91-2.68 8-3.95 12.22z",
  fill: "url(#hero_svg__linear-gradient-177)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598.45 358.55a64 64 0 006.79 0 74 74 0 00-2.84-12.22c-1.36 3.91-2.68 8-3.95 12.22z",
  fill: "url(#hero_svg__linear-gradient-178)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529.61 278.38c1.17.92 2.88 2.39 4.94 4.34a64.27 64.27 0 00-4.94-4.34z",
  fill: "url(#hero_svg__linear-gradient-179)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.25 332.65c-.1-.44-.2-.83-.3-1.27.1.44.2.83.3 1.27z",
  fill: "url(#hero_svg__linear-gradient-180)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553.94 309.5c-.24-.44-.44-.88-.68-1.32.24.39.44.88.68 1.32z",
  fill: "url(#hero_svg__linear-gradient-181)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553.21 308.08a102.25 102.25 0 00-7.21-11.87 102.25 102.25 0 017.21 11.87z",
  fill: "url(#hero_svg__linear-gradient-182)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.76 330.6a10.3 10.3 0 00-.34-1.22 12 12 0 00.34 1.22z",
  fill: "url(#hero_svg__linear-gradient-183)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535.18 283.36a6.37 6.37 0 01-.63-.64c.19.2.45.4.63.64z",
  fill: "url(#hero_svg__linear-gradient-184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546 296.11l-.74-1z",
  fill: "url(#hero_svg__linear-gradient-185)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.69 334.71c-.1-.44-.2-.83-.3-1.27.1.44.2.88.3 1.27z",
  fill: "url(#hero_svg__linear-gradient-186)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535.23 283.41l.63.63z",
  fill: "url(#hero_svg__linear-gradient-187)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M557.51 317.46c-.15-.39-.3-.78-.49-1.17.15.39.34.78.49 1.17z",
  fill: "url(#hero_svg__linear-gradient-188)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M559.46 322.83a8.71 8.71 0 01-.39-1.22 8.71 8.71 0 00.39 1.22z",
  fill: "url(#hero_svg__linear-gradient-189)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558.83 321l-.44-1.18c.14.38.29.82.44 1.18z",
  fill: "url(#hero_svg__linear-gradient-190)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.22 328.6c-.1-.39-.24-.83-.34-1.22.12.39.19.78.34 1.22z",
  fill: "url(#hero_svg__linear-gradient-191)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558.19 319.22l-.44-1.17a6.2 6.2 0 00.44 1.17z",
  fill: "url(#hero_svg__linear-gradient-192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556.09 314.14c-.2-.39-.34-.83-.54-1.22a9 9 0 01.54 1.22z",
  fill: "url(#hero_svg__linear-gradient-193)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M556.82 315.75c-.14-.39-.34-.78-.49-1.17.15.42.3.78.49 1.17z",
  fill: "url(#hero_svg__linear-gradient-194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560.63 326.65c-.09-.4-.24-.84-.34-1.23.1.39.25.79.34 1.23z",
  fill: "url(#hero_svg__linear-gradient-195)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M554.67 311c-.19-.44-.39-.83-.63-1.27.19.4.39.79.63 1.27z",
  fill: "url(#hero_svg__linear-gradient-196)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555.36 312.53c-.2-.39-.39-.83-.59-1.23a5.79 5.79 0 01.59 1.23z",
  fill: "url(#hero_svg__linear-gradient-197)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560.05 324.74c-.15-.39-.25-.83-.39-1.22a10.26 10.26 0 01.39 1.22z",
  fill: "url(#hero_svg__linear-gradient-198)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537.23 285.46c-.19-.2-.39-.44-.58-.63a7.22 7.22 0 01.58.63z",
  fill: "url(#hero_svg__linear-gradient-199)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.91 341.2c0-.44-.15-.88-.2-1.27a11.16 11.16 0 00.2 1.27z",
  fill: "url(#hero_svg__linear-gradient-200)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538.7 287a8 8 0 00-.64-.68c.25.26.44.51.64.68z",
  fill: "url(#hero_svg__linear-gradient-201)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M540.26 288.78c-.19-.24-.44-.49-.63-.73.19.24.44.49.63.73z",
  fill: "url(#hero_svg__linear-gradient-202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543.49 292.74c-.25-.29-.44-.59-.69-.88.25.34.44.59.69.88z",
  fill: "url(#hero_svg__linear-gradient-203)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538 286.24c-.2-.24-.4-.44-.59-.63.16.19.36.39.59.63z",
  fill: "url(#hero_svg__linear-gradient-204)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.52 339c-.1-.44-.15-.88-.25-1.27a11 11 0 01.25 1.27z",
  fill: "url(#hero_svg__linear-gradient-205)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.74 348.09c0-.44-.1-.83-.15-1.27.05.44.1.83.15 1.27z",
  fill: "url(#hero_svg__linear-gradient-206)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542.66 291.71c-.2-.29-.44-.53-.64-.83.2.3.44.54.64.83z",
  fill: "url(#hero_svg__linear-gradient-207)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.2 343.45a9.64 9.64 0 00-.2-1.27 11.16 11.16 0 01.2 1.27z",
  fill: "url(#hero_svg__linear-gradient-208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541.87 290.69c-.19-.25-.44-.54-.63-.78a5.25 5.25 0 00.63.78z",
  fill: "url(#hero_svg__linear-gradient-209)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.49 345.75c0-.44-.09-.88-.14-1.27.05.44.09.83.14 1.27z",
  fill: "url(#hero_svg__linear-gradient-210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541 289.71c-.19-.24-.44-.49-.63-.73.23.24.48.49.63.73z",
  fill: "url(#hero_svg__linear-gradient-211)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.48 287.9a4.13 4.13 0 00-.64-.68 8.48 8.48 0 01.64.68z",
  fill: "url(#hero_svg__linear-gradient-212)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M544.32 293.86c-.25-.29-.44-.58-.69-.92.2.29.44.58.69.92z",
  fill: "url(#hero_svg__linear-gradient-213)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545.15 295l-.74-1c.25.3.49.65.74 1z",
  fill: "url(#hero_svg__linear-gradient-214)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.13 336.86c-.1-.44-.15-.83-.25-1.27.12.41.12.83.25 1.27z",
  fill: "url(#hero_svg__linear-gradient-215)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.55 284.68a7.72 7.72 0 00-.64-.64 3.88 3.88 0 00.64.64z",
  fill: "url(#hero_svg__linear-gradient-216)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529.66 278.38c1.17.92 2.88 2.39 4.93 4.34l.64.64v.05l.63.63h.05l.64.64.09.1c.2.19.4.43.59.63s.1.1.1.15c.19.19.39.44.59.63l.14.15c.2.19.39.44.64.68l.14.15a8 8 0 00.64.68.54.54 0 01.14.2c.2.24.4.49.64.73.05.05.1.15.15.2.19.24.44.49.63.73 0 .05.1.15.15.19.19.25.44.54.63.79 0 .05.1.14.15.19.2.25.44.54.64.83a2.43 2.43 0 00.14.2c.25.29.44.58.69.88a1.17 1.17 0 01.14.19c.25.3.44.59.69.93a.24.24 0 01.09.15c.25.29.49.63.74 1 .05.05.05.1.09.15l.74 1v.09a102.43 102.43 0 017.18 11.88c.24.44.44.88.68 1.31 0 .05 0 .15.1.2.19.44.39.83.63 1.27a2.84 2.84 0 01.15.34c.2.39.39.83.59 1.22.05.15.14.25.19.39.2.4.34.79.54 1.23.05.14.15.29.19.44.15.39.35.78.49 1.17 0 .14.15.34.2.49.15.39.34.78.49 1.17a4.58 4.58 0 00.24.54l.44 1.17c.1.19.15.39.25.59l.44 1.17c.09.19.14.44.24.63a8.71 8.71 0 01.39 1.22c.1.25.15.44.24.69s.25.78.4 1.22a6.61 6.61 0 01.19.68 10.68 10.68 0 01.34 1.23c.05.24.15.48.2.73s.24.83.34 1.22c0 .24.15.49.2.78a9.26 9.26 0 00.34 1.22c0 .25.14.54.19.78s.2.83.3 1.27.14.54.19.83.2.84.29 1.28a4.2 4.2 0 00.2.83 9.46 9.46 0 01.24 1.27l.15.88c.1.43.15.83.25 1.27s.09.63.14.92.15.83.2 1.27l.14 1c.05.44.15.88.2 1.27l.15 1c0 .44.09.83.14 1.27a7.74 7.74 0 01.1 1.07c.05.44.1.83.15 1.27 0 .25.05.49.05.69a43.51 43.51 0 008.69 6.45c.78.44 1.56.87 2.4 1.27a128.23 128.23 0 00-4.55-23.21c-5.23-17.44-16.61-40.89-41.72-54.91z",
  fill: "url(#hero_svg__linear-gradient-217)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529.66 278.38c1.17.92 2.88 2.39 4.93 4.34l.64.64v.05l.63.63h.05l.64.64.09.1c.2.19.4.43.59.63s.1.1.1.15c.19.19.39.44.59.63l.14.15c.2.19.39.44.64.68l.14.15a8 8 0 00.64.68.54.54 0 01.14.2c.2.24.4.49.64.73.05.05.1.15.15.2.19.24.44.49.63.73 0 .05.1.15.15.19.19.25.44.54.63.79 0 .05.1.14.15.19.2.25.44.54.64.83a2.43 2.43 0 00.14.2c.25.29.44.58.69.88a1.17 1.17 0 01.14.19c.25.3.44.59.69.93a.24.24 0 01.09.15c.25.29.49.63.74 1 .05.05.05.1.09.15l.74 1v.09a102.43 102.43 0 017.18 11.88c.24.44.44.88.68 1.31 0 .05 0 .15.1.2.19.44.39.83.63 1.27a2.84 2.84 0 01.15.34c.2.39.39.83.59 1.22.05.15.14.25.19.39.2.4.34.79.54 1.23.05.14.15.29.19.44.15.39.35.78.49 1.17 0 .14.15.34.2.49.15.39.34.78.49 1.17a4.58 4.58 0 00.24.54l.44 1.17c.1.19.15.39.25.59l.44 1.17c.09.19.14.44.24.63a8.71 8.71 0 01.39 1.22c.1.25.15.44.24.69s.25.78.4 1.22a6.61 6.61 0 01.19.68 10.68 10.68 0 01.34 1.23c.05.24.15.48.2.73s.24.83.34 1.22c0 .24.15.49.2.78a9.26 9.26 0 00.34 1.22c0 .25.14.54.19.78s.2.83.3 1.27.14.54.19.83.2.84.29 1.28a4.2 4.2 0 00.2.83 9.46 9.46 0 01.24 1.27l.15.88c.1.43.15.83.25 1.27s.09.63.14.92.15.83.2 1.27l.14 1c.05.44.15.88.2 1.27l.15 1c0 .44.09.83.14 1.27a7.74 7.74 0 01.1 1.07c.05.44.1.83.15 1.27 0 .25.05.49.05.69a43.51 43.51 0 008.69 6.45c.78.44 1.56.87 2.4 1.27a128.23 128.23 0 00-4.55-23.21c-5.23-17.44-16.61-40.89-41.72-54.91z",
  fill: "url(#hero_svg__linear-gradient-218)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M683.7 304.86a44.8 44.8 0 017.77-6.16 44.8 44.8 0 00-7.77 6.16z",
  fill: "url(#hero_svg__linear-gradient-219)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.08 309.3a55.3 55.3 0 0117.09-11.19c-6.44 1-31.56 6.55-46.6 36.25A205.46 205.46 0 00645 358a59.47 59.47 0 006.1-3 12.47 12.47 0 001.37-.83c2.45-15.1 8.36-32.24 21.65-44.9z",
  fill: "url(#hero_svg__linear-gradient-220)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.57 334.36A205.46 205.46 0 00645 358a205.46 205.46 0 01-.43-23.64z",
  fill: "url(#hero_svg__linear-gradient-221)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.57 334.36A205.46 205.46 0 00645 358a205.46 205.46 0 01-.43-23.64z",
  fill: "url(#hero_svg__linear-gradient-222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.57 334.41a102.86 102.86 0 00-8.85 26.82 67 67 0 009.24-3.17 206.17 206.17 0 01-.39-23.65z",
  fill: "url(#hero_svg__linear-gradient-223)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.57 334.41a102.86 102.86 0 00-8.85 26.82 67 67 0 009.24-3.17 206.17 206.17 0 01-.39-23.65z",
  fill: "url(#hero_svg__linear-gradient-224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.57 334.41a102.86 102.86 0 00-8.85 26.82 67 67 0 009.24-3.17 206.17 206.17 0 01-.39-23.65z",
  fill: "url(#hero_svg__linear-gradient-225)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M683.7 304.86c-13.83 13.53-19.54 34.34-21 40.59 1.46-6.25 7.17-27.06 21-40.59z",
  fill: "url(#hero_svg__linear-gradient-226)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M683.7 304.86a44.8 44.8 0 017.77-6.16 53.21 53.21 0 00-17 11.14c-13 12.36-18.81 29.12-21.3 44a35.27 35.27 0 009.52-8.41c1.47-6.23 7.18-27.04 21.01-40.57z",
  fill: "url(#hero_svg__linear-gradient-227)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M683.7 304.86a44.8 44.8 0 017.77-6.16 53.21 53.21 0 00-17 11.14c-13 12.36-18.81 29.12-21.3 44a35.27 35.27 0 009.52-8.41c1.47-6.23 7.18-27.04 21.01-40.57z",
  fill: "url(#hero_svg__linear-gradient-228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.49 298h.25c-.44.24-.83.49-1.22.73a21.46 21.46 0 013.51-1.17.33.33 0 10-.14-.64 28 28 0 00-3.67 1.22 8.58 8.58 0 011.27-.14z",
  fill: "url(#hero_svg__linear-gradient-229)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.44 298c-.24 0-.68.09-1.27.14a55.3 55.3 0 00-17.09 11.19c-13.29 12.66-19.16 29.75-21.6 44.95l.34-.2c6.55-40.94 31.66-53.2 39.62-56.08z",
  fill: "url(#hero_svg__linear-gradient-230)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.44 298c-.24 0-.68.09-1.27.14a55.3 55.3 0 00-17.09 11.19c-13.29 12.66-19.16 29.75-21.6 44.95l.34-.2c6.55-40.94 31.66-53.2 39.62-56.08z",
  fill: "url(#hero_svg__linear-gradient-231)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.69 297.92c-.44.24-.83.49-1.22.73z",
  fill: "url(#hero_svg__linear-gradient-232)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.69 297.92c-.44.24-.83.49-1.22.73z",
  fill: "url(#hero_svg__linear-gradient-233)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.49 298h.25c-.05-.08-.1-.08-.25 0z",
  fill: "url(#hero_svg__linear-gradient-234)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M692.49 298h.25c-.05-.08-.1-.08-.25 0z",
  fill: "url(#hero_svg__linear-gradient-235)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.47 309.79a55 55 0 0117-11.14l1.22-.73h-.25c-8 2.88-33.07 15.14-39.67 56.08.15-.09.25-.14.4-.24 2.49-14.85 8.3-31.56 21.3-43.97z",
  fill: "url(#hero_svg__linear-gradient-236)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.47 309.79a55 55 0 0117-11.14l1.22-.73h-.25c-8 2.88-33.07 15.14-39.67 56.08.15-.09.25-.14.4-.24 2.49-14.85 8.3-31.56 21.3-43.97z",
  fill: "url(#hero_svg__linear-gradient-237)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.47 309.79a55 55 0 0117-11.14l1.22-.73h-.25c-8 2.88-33.07 15.14-39.67 56.08.15-.09.25-.14.4-.24 2.49-14.85 8.3-31.56 21.3-43.97z",
  fill: "url(#hero_svg__linear-gradient-238)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.12 262.4a2.68 2.68 0 01.59-.1c-.3.2-.54.44-.83.64a35.84 35.84 0 014.39-2.2.31.31 0 00-.19-.59 27.34 27.34 0 00-5 2.54 6.29 6.29 0 011-.29z",
  fill: "url(#hero_svg__linear-gradient-239)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M651.9 279.94c-12.51 15.68-20 35.42-24.53 54.38 0 .29 0 .58.1.83 11.53-49.49 35.17-67.42 44.6-72.8-.24 0-.63.15-1.07.29a73.51 73.51 0 00-19.1 17.3z",
  fill: "url(#hero_svg__linear-gradient-240)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M651.9 279.94c-12.51 15.68-20 35.42-24.53 54.38 0 .29 0 .58.1.83 11.53-49.49 35.17-67.42 44.6-72.8-.24 0-.63.15-1.07.29a73.51 73.51 0 00-19.1 17.3z",
  fill: "url(#hero_svg__linear-gradient-241)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.15 350.58c-.74 4.55-1.32 8.9-1.76 13.1a1 1 0 00.34-.05c.49-4.74 1.12-9.28 1.81-13.58a2.34 2.34 0 01-.39.53z",
  fill: "url(#hero_svg__linear-gradient-242)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.15 350.58c-.74 4.55-1.32 8.9-1.76 13.1a1 1 0 00.34-.05c.49-4.74 1.12-9.28 1.81-13.58a2.34 2.34 0 01-.39.53z",
  fill: "url(#hero_svg__linear-gradient-243)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.66 262.25c-.29.2-.59.44-.88.64a4.24 4.24 0 00.88-.64z",
  fill: "url(#hero_svg__linear-gradient-244)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.66 262.25c-.29.2-.59.44-.88.64a4.24 4.24 0 00.88-.64z",
  fill: "url(#hero_svg__linear-gradient-245)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.37 334.36c-1.32 5.52-2.35 10.95-3.22 16.22.14-.19.24-.34.39-.53.83-5.28 1.8-10.21 2.93-14.9-.05-.25-.05-.49-.1-.79z",
  fill: "url(#hero_svg__linear-gradient-246)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.37 334.36c-1.32 5.52-2.35 10.95-3.22 16.22.14-.19.24-.34.39-.53.83-5.28 1.8-10.21 2.93-14.9-.05-.25-.05-.49-.1-.79z",
  fill: "url(#hero_svg__linear-gradient-247)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.37 334.36c-1.32 5.52-2.35 10.95-3.22 16.22.14-.19.24-.34.39-.53.83-5.28 1.8-10.21 2.93-14.9-.05-.25-.05-.49-.1-.79z",
  fill: "url(#hero_svg__linear-gradient-248)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.66 262.25a5.7 5.7 0 01-.59.1 5.7 5.7 0 00.59-.1z",
  fill: "url(#hero_svg__linear-gradient-249)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.66 262.25a5.7 5.7 0 01-.59.1 5.7 5.7 0 00.59-.1z",
  fill: "url(#hero_svg__linear-gradient-250)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.07 262.4c-9.43 5.33-33.12 23.3-44.6 72.79 0 .44.1.84.1 1.13 4.44-19.45 12-39.82 24.81-55.89 7.67-9.63 15-14.85 19.45-17.44a8.53 8.53 0 01.88-.64c-.05-.1-.25-.05-.64.05z",
  fill: "url(#hero_svg__linear-gradient-251)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.07 262.4c-9.43 5.33-33.12 23.3-44.6 72.79 0 .44.1.84.1 1.13 4.44-19.45 12-39.82 24.81-55.89 7.67-9.63 15-14.85 19.45-17.44a8.53 8.53 0 01.88-.64c-.05-.1-.25-.05-.64.05z",
  fill: "url(#hero_svg__linear-gradient-252)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.07 262.4c-9.43 5.33-33.12 23.3-44.6 72.79 0 .44.1.84.1 1.13 4.44-19.45 12-39.82 24.81-55.89 7.67-9.63 15-14.85 19.45-17.44a8.53 8.53 0 01.88-.64c-.05-.1-.25-.05-.64.05z",
  fill: "url(#hero_svg__linear-gradient-253)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.54 350.05c-.69 4.3-1.32 8.84-1.81 13.58.1 0 .19-.05.34-.05.49-4.54 1.12-9.33 1.95-14.22a3.4 3.4 0 01-.48.69z",
  fill: "url(#hero_svg__linear-gradient-254)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.54 350.05c-.69 4.3-1.32 8.84-1.81 13.58.1 0 .19-.05.34-.05.49-4.54 1.12-9.33 1.95-14.22a3.4 3.4 0 01-.48.69z",
  fill: "url(#hero_svg__linear-gradient-255)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.54 350.05c-.69 4.3-1.32 8.84-1.81 13.58.1 0 .19-.05.34-.05.49-4.54 1.12-9.33 1.95-14.22a3.4 3.4 0 01-.48.69z",
  fill: "url(#hero_svg__linear-gradient-256)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.54 350.05c.14-.25.29-.44.44-.69.73-4.25 1.56-8.64 2.54-13.09 0-.29 0-.68-.1-1.12-1.03 4.69-2 9.67-2.88 14.9z",
  fill: "url(#hero_svg__linear-gradient-257)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.54 350.05c.14-.25.29-.44.44-.69.73-4.25 1.56-8.64 2.54-13.09 0-.29 0-.68-.1-1.12-1.03 4.69-2 9.67-2.88 14.9z",
  fill: "url(#hero_svg__linear-gradient-258)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.54 350.05c.14-.25.29-.44.44-.69.73-4.25 1.56-8.64 2.54-13.09 0-.29 0-.68-.1-1.12-1.03 4.69-2 9.67-2.88 14.9z",
  fill: "url(#hero_svg__linear-gradient-259)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M624.54 350.05c.14-.25.29-.44.44-.69.73-4.25 1.56-8.64 2.54-13.09 0-.29 0-.68-.1-1.12-1.03 4.69-2 9.67-2.88 14.9z",
  fill: "url(#hero_svg__linear-gradient-260)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 277.11a.62.62 0 01-.15-.1c.78.29 1.61.63 2.4 1-.88-.49-1.71-1-2.64-1.42a.33.33 0 00-.44.15.33.33 0 00.14.43c.79.4 1.57.84 2.3 1.23-.78-.71-1.37-1.1-1.61-1.29z",
  fill: "url(#hero_svg__linear-gradient-261)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.25 278c-.79-.35-1.57-.64-2.4-1a.62.62 0 00.15.1c37.23 19.64 46.17 59.21 48.27 79.53a2.27 2.27 0 00.34.15 126.85 126.85 0 00-4.64-23.7c-5.18-17.48-16.61-40.93-41.72-55.08z",
  fill: "url(#hero_svg__linear-gradient-262)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.25 278c-.79-.35-1.57-.64-2.4-1a.62.62 0 00.15.1c37.23 19.64 46.17 59.21 48.27 79.53a2.27 2.27 0 00.34.15 126.85 126.85 0 00-4.64-23.7c-5.18-17.48-16.61-40.93-41.72-55.08z",
  fill: "url(#hero_svg__linear-gradient-263)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 277.11c.24.14.78.58 1.61 1.22z",
  fill: "url(#hero_svg__linear-gradient-264)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 277.11c.24.14.78.58 1.61 1.22z",
  fill: "url(#hero_svg__linear-gradient-265)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 277.11c.24.19.83.58 1.61 1.27 25.11 14 36.54 37.47 41.72 54.86a128.4 128.4 0 014.55 23.21 1.31 1.31 0 01.34.19c-2.05-20.32-10.94-59.89-48.22-79.53z",
  fill: "url(#hero_svg__linear-gradient-266)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 277.11c.24.19.83.58 1.61 1.27 25.11 14 36.54 37.47 41.72 54.86a128.4 128.4 0 014.55 23.21 1.31 1.31 0 01.34.19c-2.05-20.32-10.94-59.89-48.22-79.53z",
  fill: "url(#hero_svg__linear-gradient-267)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528 277.11c.24.19.83.58 1.61 1.27 25.11 14 36.54 37.47 41.72 54.86a128.4 128.4 0 014.55 23.21 1.31 1.31 0 01.34.19c-2.05-20.32-10.94-59.89-48.22-79.53z",
  fill: "url(#hero_svg__linear-gradient-268)"
})));

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 695.29 536.47"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/hero.431d8bcd.svg";
export { SvgHero as ReactComponent };